import React, { useState, useEffect, useMemo, useRef } from "react"
import { useNavigate, useParams, useLocation, Link } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm, useWatch } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  RichTextEditor,
  UFDate,
  UFEditor,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import LoadingButton from "../../../components/Common/LoadingButton"
import lightTrash from "../../../assets/icons/light-trash.svg"
import close from "../../../assets/icons/close.svg"
import moment from "moment"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { fetchPurchase } from "../../../services/procurement/purchaseOrder"
import { ContentState, convertToRaw, EditorState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import Unit from "../../../components/Common/chooseFields/unit"
import { useDispatch, useSelector } from "react-redux"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import {
  fetchFinanceVoucherSingle,
  postFinanceVoucher,
} from "../../../services/finance/finance"
import VoucherTypes from "../../../components/Common/chooseFields/voucherTypes"
import ProductList from "../../../components/Common/chooseFields/productList"
import ProjectNo from "../../../components/Common/chooseFields/projectno"
import closeIcon from "../../../assets/icons/close.svg"
import {
  fetchMRRequesting,
  fetchRequestPOvoucher,
  fetchRfqReference,
} from "../../../services/procurement/materialrequest"
import VoucherEntryLi from "../../../components/Common/chooseFields/voucherEntryLi"
import VoucherEntrySearch from "."
import DebitCreditDrop from "../../../components/Common/chooseFields/debitCredit"
import StockProductList from "../../../components/Common/chooseFields/stockProduct"
import RFQList from "../../../components/Common/chooseFields/rfqLi"
import htmlToDraft from "html-to-draftjs"
import MRRequstingLi from "../../../components/Common/chooseFields/materialRequstionLi"
import NumberFormat from "../../../utils/numberFormat"
import ManufactureLi from "../../../components/Common/chooseFields/manufactureLi"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getFinanceVoucherLi } from "../../../services/Settings/dropdown"
import SkeletonLoading from "../../../components/VerticalLayout/SkeletonLoader"
// import SkeletonLoadingvoucher from "./skelitonvouher"
import { changeSidebarSize } from "../../../store/actions"
import { getCode } from "../../../services/inventory"
import ReferenceType from "../../../components/Common/chooseFields/refType"
import { toSnakeCase } from "../../../utils/toSnakeCase"
import { capitalize, set, values } from "lodash"
import NatureOfTransactions from "../../../components/Common/chooseFields/natureOfTransactions"
import FinCostCenterLi from "../../../components/Common/chooseFields/costCenterFinLi"
import { openAndPrintFile } from "../../../utils/handleDownload"
import DebitCreditDrops from "../../../components/Common/chooseFields/debitCreditTypes"
import BankPaymentType from "../../../components/Common/chooseFields/paymentType"
import BankCurrency from "../../../components/Common/chooseFields/bankCurrency"
import SupplierContact from "../../../components/Common/chooseFields/supplierContact"

const EditPurchase = ({ fromDashboard, poValue, toggle }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Voucher Entry${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const navigate = useNavigate()
  const { editId } = useParams()
  const id = fromDashboard ? "" : editId
  console.log(`editId`, editId)
  const [isLoading, setIsLoading] = useState(false)
  const [isVoucherLoading, setIsVoucherLoading] = useState(false)
  const [idPO, setIdPO] = useState()
  const [responseData, setResponseData] = useState()
  const [vatCheck, setVatCheck] = useState(false)
  const [discountCheck, setDiscountCheck] = useState(false)
  const [discountAfterCheck, setDiscountAfterCheck] = useState(false)
  const [shippingCheck, setShippingCheck] = useState(false)
  const [othersCheck, setOthersCheck] = useState(false)
  const [pdcCheck, setPdcCheck] = useState(false)
  const [retentionCheck, setRetentionCheck] = useState(false)
  const [advRetentionCheck, setAdvRetentionCheck] = useState(false)
  const [modal, setModal] = useState(false)
  const [viewVouchersLi, setViewVouchersLi] = useState(false)
  const [contraId, setContraId] = useState(null)
  const [poData, setPoData] = useState()
  const [projectId, setProjectID] = useState()
  const [viewData, setViewData] = useState()
  const [voucherId, setVoucherId] = useState()
  const [materialData, setMaterialData] = useState()
  const [rSelected, setRSelected] = useState(2)
  const [activeItemId, setActiveItemId] = useState(null)
  const [confirmModal, setConfirmModal] = useState(false)
  const [printID, setPrintID] = useState(false)
  const [transactionModal, setTransactionModal] = useState(false)
  const [bankModal, setBankModal] = useState(false)
  const [ccModal, setCCModal] = useState(false)
  const [editPartial, setEditPartial] = useState(false) // For edit partial payment modal Edited By: Adithyan

  const natureRefs = useRef([])

  const dispatch = useDispatch()

  const now = moment()
  const desimalrange = localStorage.getItem("desimalrange")

  const toggleSelect = () => setModal(!modal)
  const toggleSelectModal = () => {
    console.log(`viewData toggleSelectModal`, viewData)

    const removeIds = watch("voucher_contra_partial_pay")?.map((item, i) => i)
    removeIds &&
      removeIds?.length > 1 &&
      removeIds?.map(i => contraPartialListRemove(i))
    setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)
    setValue(`voucher_contra.${viewData?.currIndex}.partial_payments`, [])
    // setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)

    setModal(!modal)
  }

  const body = document.body.getAttribute("data-sidebar-size")

  const schema = yup.object().shape({
    ...(discountCheck && {
      discount: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    ...(shippingCheck && {
      shipping_charge: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    ...(othersCheck && {
      other_charge: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    voucher_id: yup.mixed().required("Voucher Type is Required"),
    po_date: yup.mixed().required("Date is Required"),
    ...(retentionCheck && {
      retention_id: yup.mixed().required("Retention is Required"),
    }),
    ...(advRetentionCheck && {
      adv_retention_id: yup.mixed().required("Advance Retention is Required"),
    }),
    ...(vatCheck && {
      vat_id: yup.mixed().required("VAT is Required"),
    }),
    ...((voucherId == 1 ||
      voucherId == 3 ||
      voucherId == 6 ||
      voucherId == 8 ||
      voucherId == 21 ||
      ([13, 15, 4, 18].includes(voucherId) == 13 && rSelected == 2)) && {
      voucher_contra: yup.array().of(
        yup.object().shape({
          account_id: yup.mixed().required("Account Head is Required"),
          debit: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Debit Amount must be a valid number with up to 4 digits after the decimal point"
            )
            .required("Debit Amount is required"),
          credit: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Credit Amount must be a valid number with up to 4 digits after the decimal point"
            )
            .required("Credit Amount is required"),
        })
      ),
    }),
    ...(voucherId == 16 && {
      credit_id: yup.mixed().required("Party Name is Required"),
      address: yup.string().required("Address is Required"),
      voucher_materials: yup.array().of(
        yup.object().shape({
          product_id: yup.mixed().required("Product Code is Required"),
          qnt: yup
            .string()
            .required("Quantity is required")
            .matches(
              /^([+]?)\d+(\.\d{1,2})?$/,
              "Quantity must be a number with up to 4 decimal places"
            ),
          unit_price: yup
            .string()
            .required("Unit Price is required")
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Unit Price must be a number with up to 4 decimal places"
            ),
        })
      ),
      // voucher_contra: yup.array().of(
      //   yup
      //     .object()
      //     .shape({
      //       account_id: yup.mixed().required("Particulars is Required"),
      //       debit: yup
      //         .string()
      //         .matches(
      //           /^([+]?)\d+(\.\d{1,4})?$/,
      //           "Debit Amount must be a valid number with up to 4 digits after the decimal point"
      //         )
      //         .nullable(),
      //       credit: yup
      //         .string()
      //         .matches(
      //           /^([+]?)\d+(\.\d{1,4})?$/,
      //           "Credit Amount must be a valid number with up to 4 digits after the decimal point"
      //         )
      //         .nullable(),
      //     })
      //     .test(
      //       "debit-or-credit",
      //       "Either Debit or Credit must be greater than 0",
      //       value => {
      //         const debit = parseFloat(value.debit || "0")
      //         const credit = parseFloat(value.credit || "0")
      //         return debit > 0 || credit > 0
      //       }
      //     )
      // ),
    }),
    ...(voucherId == 15 &&
      rSelected == 1 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Purchase Ledger is Required"),
        voucher_purchase: yup.array().of(
          yup.object().shape({
            qnt: yup
              .number()
              .typeError("Quantity must be a number")
              .required("Quantity is required")
              .test(
                "max-qnt",
                "Quantity exceeds available quantity",
                function (value) {
                  const { ordered_quantity, already_created } =
                    this.options.parent
                  const maxAllowed =
                    (ordered_quantity || 0) - (already_created || 0)
                  return value <= maxAllowed
                }
              ),
          })
        ),
      }),
    ...(voucherId == 13 &&
      rSelected == 1 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Sales Account is Required"),
        sale_total: yup.string().required("Amount is Required"),
      }),
    ...([13, 15].includes(Number(voucherId)) &&
      rSelected == 3 && {
        credit_id: yup.mixed().required("Party Name is Required"),
      }),
    ...(voucherId == 13 &&
      rSelected == 4 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Sales Account is Required"),
      }),
    // payable_account: yup.mixed().required("Purchase Ledger is required"),
    //   recieved_date: yup
    //     .mixed()
    //     .test(
    //       "is-future-date",
    //       "Make sure the received date is forward-looking",
    //       function (value) {
    //         if (!value) return true
    //         const currentDate = moment()
    //         const selectedDate = moment(value)
    //         return selectedDate.isSameOrBefore(currentDate, "day")
    //       }
    //     )
    //     .required("Received date is required"),
    //   grnproductlist: yup.array().of(
    //     yup.object().shape({
    //       product_code: yup.mixed().required("product code is required"),
    //       description: yup.string().required("description is required"),
    //       unit: yup.mixed().required("Unit is Required"),
    //       received_quantity: yup
    //         .string()
    //         .matches(
    //           /^\d*(\.\d+)?$/,
    //           "Pending quantity must be a non-negative number"
    //         )
    //         .test(
    //           "max",
    //           "pending quantity must not exceed the ordered quantity",
    //           function (value) {
    //             const { pending_quantity } = this.parent
    //             return parseInt(value) <= pending_quantity
    //           }
    //         )
    //         .required("pending quantity is required"),
    //     })
    //   ),
  })

  const location = useLocation()
  const crumb = location?.state?.menuLabel || ""

  const loggedUser = useSelector(state => state?.Login.loggedUser)

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    setFocus,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      po_id: null,
      other_charge: 0,
      shipping_charge: 0,
      po_date: moment(now, "YYYY-MM-DD").toDate(),
      code_edit: 0,
      voucher_materials: [
        {
          qnt: "",
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_purchase: [
        {
          qnt: "",
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_receipt: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_materialout: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
          amount: 0,
        },
      ],
      voucher_destination: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
          amount: 0,
        },
      ],
      voucher_source: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_contra: [
        {
          nature: [8, 3, 15].includes(voucherId)
            ? { label: "Dr", value: "debit" }
            : { label: "Cr", value: "credit" },
          account_id: null,
          debit: "",
          credit: "",
          voucher_id: null,
          partial_payments: [],
        },
      ],
      voucher_sales_acc: [
        {
          amount: 0,
          rate: "",
          account_id: null,
        },
      ],
      voucher_contra_partial_pay: [
        {
          nature: { label: "Cr", value: "credit" },
          account_id: null,
          amount: 0,
          date: moment(now, "DD-MM-MMMM").toDate(),
          // credit: 0,
          voucher_id: null,
          // partial_payments: [],
        },
      ],
    },
  })
  const getUniqueCode = async (code, modal, type) => {
    const response = await getCode(code, modal, type)
    if (!editId) {
      setValue("code", response?.code?.code)
    }
    setValue("code_edit", response?.code?.manualoverride)
  }
  console.log(`code_edit`, watch("code_edit"))

  useEffect(() => {
    // if (!editId) {
    getUniqueCode(
      "ref_number",
      "VoucherEntry",
      `Voucher - ${
        watch(`voucher_id`)?.label
          ? ucfirst(watch(`voucher_id`)?.label)
          : "Contra"
      }`
    )
    // }
  }, [])
  useEffect(() => {
    const resetValue = getValues()
    console.log(`resetValue`, resetValue)
    setValue("code", resetValue?.code)
    setValue("po_date", resetValue?.po_date)
    if (watch("voucher_id")) {
      setVoucherId(watch("voucher_id")?.value)
    }
    if (watch("voucher_id")?.value == 3 && !editId) {
      // setValue(`voucher_contra.${0}.nature`, { label: "Dr", value: "debit" })
      setValue(`voucher_contra.${0}.amount`, 0)
    }
    // if (watch("voucher_id")?.value == 6 && !editId) {
    //   setValue(`voucher_contra.${0}.nature`, { label: "Cr", value: "credit" })
    // }
    if (watch("voucher_id")?.value == 16 && !editId && loggedUser) {
      let activeGeneral = getDescriptionByCategoryId(
        loggedUser?.active_terms,
        1
      )
      let activeDeliver = getDescriptionByCategoryId(
        loggedUser?.active_terms,
        2
      )
      setValue(
        "general_terms",
        activeGeneral ? formatTemplate(activeGeneral) : ""
      )
      setValue(
        "delivery_terms",
        activeDeliver ? formatTemplate(activeDeliver) : ""
      )
    }
    if (
      watch("voucher_id")?.value == 15 &&
      [1, 2, 3].includes(rSelected) &&
      !editId
    ) {
      setValue("ref_code", "")
      setValue("ref_date", moment(now, "DD-MM-YYYY").toDate())
    }
  }, [watch("voucher_id")])

  console.log(`codeee`, watch("code"))

  const getDescriptionByCategoryId = (terms, categoryId) => {
    const term = terms?.find(term => term.category_id === categoryId)
    return term?.description || null // Return description or null if not found
  }

  const formatTemplate = html => {
    let editorState = EditorState.createEmpty()
    if (html === null) {
      return editorState
    }
    const contentBlock = htmlToDraft(html)
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    )
    editorState = EditorState.createWithContent(contentState)
    return editorState
  }

  const {
    fields: poFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "grnproductlist",
  })
  const watchTest = useWatch({
    control,
    name: "grnproductlist",
    defaultValue: poFields,
  })
  useEffect(() => {
    if (location?.state?.id) {
      reset({
        voucher_id:
          location?.state && location?.state?.chkField == "MR"
            ? {
                label: "Stock Journal",
                value: 12,
                voucher_type: "Stock Journal",
              }
            : {
                label: "Purchase Order",
                value: 16,
                voucher_type: "Purchase Order",
              },
      })

      getUniqueCode(
        "ref_number",
        "VoucherEntry",
        `Voucher - ${
          location?.state && location?.state?.chkField == "MR"
            ? "Stock Journal"
            : "Purchase Order"
        }`
      )
      setActiveItemId(
        location?.state && location?.state?.chkField == "MR" ? 12 : 16
      )

      if (location?.state?.type === "from_po") {
        setCardOpen(false)
      }

      // fetchPotData(location?.state?.id)
    }
    if (location?.state?.chkField == "MR") {
      fetchMaterialRequstiotion(location?.state?.id)
      setValue("material_requisition_id", {
        label: location?.state?.code,
        value: location?.state?.id,
      })
    } else if (location?.state && location?.state?.chkField != "MR") {
      fetchRfqData(location?.state?.id)
      setIdPO(location?.state?.id)
    }
    setValue(
      "address",
      loggedUser?.settings?.companyaddress
        ? loggedUser?.settings?.companyaddress
        : ""
    )
  }, [location])

  useEffect(() => {
    if (fromDashboard) {
      reset({
        po_id: poValue?.value && {
          label: poValue?.label,
          value: poValue?.value,
        },
      })

      handlePoChange(poValue)
    }
  }, [fromDashboard])

  const getPercentRev = (a, b) => {
    return ((Number(a) / Number(b)) * 100).toFixed(desimalrange)
  }

  useEffect(() => {
    const fetchEditData = async id => {
      const response = await fetchFinanceVoucherSingle(id)
      let materialDataArr
      if (response?.data?.voucher_id == 16) {
        materialDataArr = response?.data?.purchaseorder?.materials?.map(dt => ({
          id: dt?.id,
          product_id: {
            label: dt?.product?.product_code,
            value: dt?.product?.id,
          },
          unit: {
            label: dt?.product?.unit?.unit_code,
            value: dt?.product?.unit?.id,
          },
          description: dt?.product?.description,
          qnt: dt?.po_quantity,
          unit_price: dt?.unit_price,
          sub_price: Number(dt?.po_quantity) * Number(dt?.unit_price),
        }))
      }
      let contraArr = response?.data?.journal_entry?.journal_entry_details?.map(
        dt => ({
          nature: {
            label: Number(dt?.debit_amount) > 0 ? "Dr" : "Cr",
            value: Number(dt?.debit_amount) > 0 ? "debit" : "credit",
          },
          account_id: {
            label: dt?.ledger?.name,
            value: dt?.ledger?.id,
            ...dt?.ledger,
          },
          debit: Number(dt?.debit_amount),
          credit: Number(dt?.credit_amount),
          cost_center_id: dt?.cost_center_id
            ? {
                ...dt?.costcenter,
                label: dt?.costcenter?.name,
                value: dt?.costcenter?.id,
              }
            : null,
          transaction_type: dt?.transaction_type?.id
            ? {
                label: dt?.transaction_type?.label,
                value: dt?.transaction_type?.id,
              }
            : null,
          // voucher_id:
          partial_payments: dt?.voucher_partial_payment?.map(partial => ({
            id: partial?.id,
            amount: partial?.amount,
            chk: dt?.id,
            nature: {
              value: partial?.credit_debit,
              label: partial?.credit_debit == "debit" ? "Dr" : "Cr",
            },
            code: partial?.code,
            ref_id: {
              value: partial?.ref_id,
              label:
                partial?.ref_id == 1
                  ? "Advance"
                  : partial?.ref_id == 2
                  ? "Against Ref"
                  : "New Ref",
            },
            date: partial?.date,
            parent_ledger_id: partial?.parent_ledger_id,
            ...(partial?.parent_voucher_entry_id && {
              voucher_id: partial?.parent_voucher_entry_id,
            }),
          })),

          ...(dt?.bank_payments?.length && {
            bank_date: moment(dt?.bank_payments[0]?.date).format("DD-MM-YYYY"),
            instrument_no: dt?.bank_payments[0]?.instrument_no,
            instrument_date: moment(
              dt?.bank_payments[0]?.instrument_date
            ).format("DD-MM-YYYY"),
            bank_amount: dt?.bank_payments[0]?.amount,
            remarks: dt?.bank_payments[0]?.remarks,
            payment_type_id: dt?.bank_payments[0]?.payment_type_id
              ? {
                  label: dt?.bank_payments[0]?.payment_type_value?.value,
                  value: dt?.bank_payments[0]?.payment_type_value?.id,
                }
              : null,
            currency: dt?.bank_payments[0]?.currency
              ? {
                  label: dt?.bank_payments[0]?.currency_value?.value,
                  value: dt?.bank_payments[0]?.currency_value?.id,
                }
              : null,
          }),
        })
      )

      let saleAccArrRe =
        response?.data?.journal_entry?.journal_entry_details?.slice(0, -1)

      let saleAccArr = saleAccArrRe?.map((dt, index) => ({
        account_id: {
          label: dt?.ledger?.name,
          value: dt?.ledger?.id,
          ...dt?.ledger,
        },
        amount:
          Number(dt?.credit_amount) &&
          response?.data?.voucher_invoice == "Sales Account"
            ? Number(dt?.credit_amount)
            : Number(dt?.debit_amount) &&
              response?.data?.voucher_invoice == "Sales Account"
            ? -Number(dt?.debit_amount)
            : Number(dt?.debit_amount) &&
              response?.data?.voucher_invoice == "Purchase Account"
            ? Number(dt?.debit_amount)
            : -Number(dt?.credit_amount),

        rate:
          index === 0
            ? ""
            : `${
                Number(dt?.debit_amount) &&
                response?.data?.voucher_invoice == "Sales Account"
                  ? "-"
                  : Number(dt?.credit_amount) &&
                    response?.data?.voucher_invoice == "Purchase Account"
                  ? "-"
                  : ""
              }${(
                (Number(dt?.credit_amount || dt?.debit_amount) /
                  Number(
                    saleAccArrRe[0]?.credit_amount ||
                      saleAccArrRe[0]?.debit_amount
                  )) *
                100
              ).toFixed(2)}`,
      }))

      // let partialPaymentArr =

      const journalEntryDetails =
        response?.data?.journal_entry?.journal_entry_details || []

      const hasAccountId3 = journalEntryDetails.some(
        detail => detail?.account_id == 3
      )
      const hasAccountId4 = journalEntryDetails.some(
        detail => detail?.account_id == 4
      )

      const hasAccountId2 = journalEntryDetails.some(
        detail => detail?.ledger?.account_group_id == 2
      )

      const hasAccountGroupId4 = journalEntryDetails.some(
        detail => detail?.ledger?.account_group_id == 4
      )

      const hasAccountGroupId17 = journalEntryDetails.some(
        detail => detail?.ledger?.account_group_id == 17
      )
      console.log(`hasAccountId2`, hasAccountId2)
      setRetentionCheck(hasAccountId2)
      setAdvRetentionCheck(hasAccountGroupId4)

      const shippingCharge = hasAccountId3
        ? journalEntryDetails.find(detail => detail?.account_id == 3)
            ?.debit_amount || 0
        : 0
      const otherCharge = hasAccountId3
        ? journalEntryDetails.find(detail => detail?.account_id == 4)
            ?.debit_amount || 0
        : 0

      setShippingCheck(
        Number(response?.data?.purchaseorder?.shipping_charge) != 0
          ? true
          : false
      )
      setOthersCheck(
        Number(response?.data?.purchaseorder?.other_charge) != 0 ? true : false
      )
      setVatCheck(response?.data?.vat != 0 ? true : false)
      setDiscountCheck(response?.data?.discount != 0 ? true : false)
      setRSelected(
        response?.data?.voucher_invoice == "Purchase Voucher" ||
          response?.data?.voucher_invoice == "Sales Voucher"
          ? 2
          : response?.data?.voucher_invoice == "Sales Account" ||
            response?.data?.voucher_invoice == "Purchase Account"
          ? 3
          : response?.data?.voucher_invoice == "Sales Product Invoice"
          ? 4
          : 1
        // response?.data?.storeHistory?.length &&
        //   response?.data?.storeHistory[0]?.activity == "remove"
        //   ? 1
        //   : 2
      )
      let saleSub = 0
      if (response?.data?.voucher_id == 13) {
        // const subtotal = Number(response?.data?.sub_total)
        const subtotal = journalEntryDetails?.[0]?.debit_amount
        const vatAmt =
          journalEntryDetails.find(
            detail => detail?.ledger?.account_group_id == 17
          )?.credit_amount || 0
        const advRetAmt =
          journalEntryDetails.find(
            detail => detail?.ledger?.account_group_id == 4
          )?.debit_amount || 0
        const retAmt =
          journalEntryDetails.find(
            detail => detail?.ledger?.account_group_id == 2
          )?.debit_amount || 0

        // const vatPer = Number(response?.data?.vat) / 100
        // const vatAmount = Number(subtotal * vatPer).toFixed(3)

        console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

        saleSub =
          Number(vatAmt) != 0
            ? Number(
                Number(subtotal) -
                  Number(vatAmt) +
                  Number(advRetAmt) +
                  Number(retAmt)
              ).toFixed(desimalrange || 2)
            : Number(response?.data?.sale_total).toFixed(desimalrange || 2)
      } else if ([4, 18, 15].includes(response?.data?.voucher_id)) {
        // const subtotal = Number(response?.data?.sub_total)
        const subtotal = journalEntryDetails?.[0]?.debit_amount
          ? journalEntryDetails?.[0]?.debit_amount
          : journalEntryDetails?.[0]?.credit_amount
        const vatEntry = journalEntryDetails.find(
          detail => detail?.ledger?.account_group_id === 17
        )

        const vatAmt = vatEntry
          ? vatEntry.credit_amount || vatEntry.debit_amount || 0
          : 0
        // Advance return amount (account_group_id == 4)
        const advRetEntry = journalEntryDetails.find(
          detail => detail?.ledger?.account_group_id == 4
        )
        const advRetAmt = advRetEntry
          ? advRetEntry.debit_amount || advRetEntry.credit_amount || 0
          : 0

        // Return amount (account_group_id == 2)
        const retEntry = journalEntryDetails.find(
          detail => detail?.ledger?.account_group_id == 2
        )
        const retAmt = retEntry
          ? retEntry.debit_amount || retEntry.credit_amount || 0
          : 0

        // const vatPer = Number(response?.data?.vat) / 100
        // const vatAmount = Number(subtotal * vatPer).toFixed(3)

        console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

        saleSub =
          Number(vatAmt) != 0
            ? Number(
                Number(subtotal) -
                  Number(vatAmt) +
                  Number(advRetAmt) +
                  Number(retAmt)
              ).toFixed(2)
            : subtotal
      }

      // const vatAmount = journalEntryDetails
      //   .filter(entry => entry.ledger?.account_group_id === 17)
      //   .map(entry => entry.credit_amount)
      const vatAmount = journalEntryDetails
        .filter(entry => entry.ledger?.account_group_id === 17)
        .map(entry => entry.credit_amount || entry.debit_amount || 0)

      const vatCalType = journalEntryDetails?.find(
        entry => entry.ledger?.account_group_id === 17
      )?.ledger?.vat_cal

      const vatCalAmt =
        vatCalType == 1
          ? Number(saleSub) -
            Number(
              journalEntryDetails
                .filter(entry => entry.ledger?.account_group_id === 2)
                .map(entry => entry.debit_amount) || 0
            ) -
            Number(
              journalEntryDetails
                .filter(entry => entry.ledger?.account_group_id === 4)
                .map(entry => entry.debit_amount) || 0,
              saleSub || 0
            )
          : saleSub || 0

      console.log(`materialDataArr materialDataArr`, materialDataArr)

      const costCheck =
        response?.data?.journal_entry?.journal_entry_details.find(
          entry => entry.costcenter?.id
        )

      reset({
        code: response?.data?.ref_number,
        inv_date: response?.data?.inv_date,
        chk_sale_total: response?.data?.sale_total || 0,
        cost_center_id:
          costCheck &&
          [
            "response?.data?.voucher_invoice",
            "Purchase Invoice",
            "Sales Invoice",
          ].includes(response?.data?.voucher_invoice)
            ? {
                ...costCheck,
                label: costCheck?.costcenter?.name,
                value: costCheck?.costcenter?.id,
              }
            : null,
        inv_num: response?.data?.inv_num
          ? {
              value: response?.data?.parent_voucher?.id,
              label: response?.data?.parent_voucher?.ref_number,
            }
          : null,
        ref_code: response?.data?.journal_entry?.journal_entry_details?.find(
          detail => detail?.voucher_partial_payment?.length > 0
        )?.voucher_partial_payment?.[0]?.code,
        // response?.data?.journal_entry?.journal_entry_details?.[0]
        //   ?.voucher_partial_payment?.[0]?.code,
        ref_date: response?.data?.journal_entry?.journal_entry_details?.find(
          detail => detail?.voucher_partial_payment?.length > 0
        )?.voucher_partial_payment?.[0]?.date,
        // response?.data?.journal_entry?.journal_entry_details?.[0]
        //   ?.voucher_partial_payment?.[0]?.date,
        retention_id: hasAccountId2
          ? {
              label: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 2
              )?.ledger.name,
              value: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 2
              )?.account_id,
              ...journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 2
              )?.ledger,
            }
          : null,
        adv_retention_id: hasAccountGroupId4
          ? {
              label: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 4
              )?.ledger.name,
              value: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 4
              )?.account_id,
              ...journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 4
              )?.ledger,
            }
          : null,
        vat_id: hasAccountGroupId17
          ? {
              label: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 17
              )?.ledger.name,
              value: journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 17
              )?.account_id,
              ...journalEntryDetails.find(
                entry => entry.ledger?.account_group_id === 17
              )?.ledger,
            }
          : null,
        retention: hasAccountId2
          ? journalEntryDetails
              .filter(entry => entry.ledger?.account_group_id === 2)
              .map(entry => entry.debit_amount)
          : 0,
        retention_amount: getPercentRev(
          journalEntryDetails
            .filter(entry => entry.ledger?.account_group_id === 2)
            .map(entry => entry.debit_amount) || 0,
          saleSub || 0
        ),
        vat_amount: getPercentRev(vatAmount || 0, vatCalAmt || 0),
        adv_retention: hasAccountGroupId4
          ? journalEntryDetails
              .filter(entry => entry.ledger?.account_group_id === 4)
              .map(entry => entry.debit_amount)
          : 0,
        adv_retention_amount: getPercentRev(
          journalEntryDetails
            .filter(entry => entry.ledger?.account_group_id === 4)
            .map(entry => entry.debit_amount) || 0,
          saleSub || 0
        ),
        voucher_id: {
          label: response?.data?.voucherType,
          value: response?.data?.voucher_id,
          voucher_type: response?.data?.voucherType,
        },
        sup_cont_per_id: response?.data?.supplierContactPerson_id
          ? {
              label: response?.data?.supplierContactPerson,
              value: response?.data?.supplierContactPerson_id,
            }
          : null,
        material_request_id: {
          label: response?.data?.purchaseorder
            ? response?.data?.purchaseorder?.material_request?.code
            : response?.data?.recipt_note?.purchase_order?.voucher_entry
                ?.ref_number,
          value: response?.data?.purchaseorder
            ? response?.data?.purchaseorder?.material_request?.id
            : response?.data?.recipt_note?.purchase_order?.voucher_entry?.id,
        },
        rfq_id: response?.data?.purchaseorder?.rfq_id
          ? {
              label: response?.data?.purchaseorder?.rfq?.code,
              value: response?.data?.purchaseorder?.rfq_id,
            }
          : null,
        manufacturing_journal_id: {
          label: response?.data?.manufacturing_journal?.code,
          value: response?.data?.manufacturing_journal?.id,
        },
        purchase_order_id_ref: {
          label: response?.data?.recipt_note
            ? response?.data?.recipt_note?.purchase_order?.voucher_entry
                ?.ref_number
            : response?.data?.purchasevoucher?.purchase_order?.voucher_entry
                ?.ref_number,
          value: response?.data?.recipt_note
            ? response?.data?.recipt_note?.purchase_order?.voucher_entry?.id
            : response?.data?.purchasevoucher?.purchase_order?.voucher_entry
                ?.id,
        },
        project_code: {
          label: response?.data?.project?.project_code,
          value: response?.data?.project?.id,
        },
        request_date: response?.data?.purchaseorder?.date,
        exp_Delivery_date: response?.data?.purchaseorder?.exp_Delivery_date,
        ...(response?.data?.voucher_id == 13 && { sale_unit: "Lsm" }),
        ...(response?.data?.voucher_id == 13 && { sale_qty: "1" }),
        address: response?.data?.purchaseorder?.address,
        narration: response?.data?.narration,
        po_date: response?.data?.date,
        discount: response?.data?.discount,
        net_total:
          response?.data?.voucher_id == 13
            ? journalEntryDetails?.[0]?.debit_amount
            : journalEntryDetails?.[0]?.credit_amount,
        // sale_total: response?.data?.sub_total,
        shipping_charge: response?.data?.purchaseorder?.shipping_charge
          ? response?.data?.purchaseorder?.shipping_charge
          : shippingCharge,
        other_charge: response?.data?.purchaseorder?.other_charge
          ? response?.data?.purchaseorder?.other_charge
          : otherCharge,
        voucher_materials: materialDataArr,
        voucher_purchase: materialDataArr,
        voucher_receipt: materialDataArr,
        voucher_materialout: materialDataArr,
        voucher_source: materialDataArr,
        voucher_contra: contraArr,
        voucher_sales_acc: saleAccArr,
        sub_total:
          response?.data?.vat != 0
            ? Number(saleSub).toFixed(desimalrange)
            : response?.data?.sub_total,
        sale_total: saleSub,
        credit_id:
          response?.data?.voucher_id == 13
            ? {
                label: response?.data?.debit?.name,
                value: response?.data?.debit?.id,
              }
            : {
                label: response?.data?.credit?.name,
                value: response?.data?.credit?.id,
              },
        debit_id:
          response?.data?.voucher_id == 13
            ? {
                label: response?.data?.credit?.name,
                value: response?.data?.credit?.id,
              }
            : {
                label: response?.data?.debit?.name,
                value: response?.data?.debit?.id,
              },
        project_ids: {
          label: response?.data?.project?.project_code,
          value: response?.data?.project?.id,
          id: response?.data?.project?.id,
          amount: response?.data?.project?.amount,
        },
        general_terms: response?.data?.purchaseorder?.general_terms
          ? formatTemplate(response?.data?.purchaseorder?.general_terms)
          : "",
        delivery_terms: response?.data?.purchaseorder?.delivery_terms
          ? formatTemplate(response?.data?.purchaseorder?.delivery_terms)
          : "",
      })
    }

    if (editId) {
      fetchEditData(editId)
    }
    if (!editId) dispatch(changeSidebarSize("sm"))
  }, [editId])
  const [refreshDropdown, setRefreshDropdown] = useState(false)

  const handleLedgerCreationSuccess = (newLedger, name) => {
    setRefreshDropdown(prev => !prev) // Refresh dropdown
    console.log(`newLedger`, newLedger, name)

    setValue(name, {
      label: newLedger?.data?.name,
      value: newLedger?.data?.id,
      ...newLedger?.data,
    })
    clearErrors(name)
    setValue("vat_amount", newLedger?.data?.vat_per || 0)

    let parts = []
    if (name.includes("voucher_contra") || name.includes("voucher_sales_acc")) {
      parts = name.split(".")
      if (parts[0] == "voucher_contra") {
        handleType(newLedger?.data, parts[1])
      }
      if (
        parts[0] == "voucher_sales_acc" &&
        newLedger?.data?.account_group_id == 17
      ) {
        setValue(
          `${parts[0]}.${parts[1]}.rate`,
          Number(newLedger?.data?.vat_per || 0)
        )
        handleRateChange(Number(newLedger?.data?.vat_per || 0), parts[1])
      }
      console.log(`parts`, watch(`${parts[0]}.${parts[1]}`))
    }
  }

  const handleVatCheck = dt => {
    console.log(`handleVatCheck`, dt)

    setVatCheck(!dt)
  }
  const handleDiscountCheck = dt => {
    setDiscountCheck(!dt)
    setValue("discount")
  }

  const {
    fields: materialFields,
    append: materialListAppend,
    remove: materialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_materials",
  })
  const {
    fields: purchaseFields,
    append: purchaseListAppend,
    remove: purchaseListRemove,
  } = useFieldArray({
    control,
    name: "voucher_purchase",
  })

  const {
    fields: receiptFields,
    append: receiptListAppend,
    remove: receiptListRemove,
  } = useFieldArray({
    control,
    name: "voucher_receipt",
  })

  const {
    fields: materialOutFields,
    append: materialOutListAppend,
    remove: materialOutListRemove,
  } = useFieldArray({
    control,
    name: "voucher_materialout",
  })

  const {
    fields: stockTransferSourceFields,
    append: stockTransferSourceAppend,
    remove: stockTransferSourceRemove,
  } = useFieldArray({
    control,
    name: "voucher_source",
  })

  const {
    fields: stockTransferDestinationFields,
    append: stockTransferDestinationAppend,
    remove: stockTransferDestinationRemove,
  } = useFieldArray({
    control,
    name: "voucher_destination",
  })

  const {
    fields: contraFields,
    append: contraListAppend,
    remove: contraListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra",
  })
  const {
    fields: salesAccFields,
    append: salesAccAppend,
    remove: salesAccRemove,
  } = useFieldArray({
    control,
    name: "voucher_sales_acc",
  })

  const {
    fields: contraFieldsPartial,
    append: contraPartialListAppend,
    remove: contraPartialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra_partial_pay",
  })

  const handleModalData = i => {
    const data = getValues()

    const chkDataName =
      data?.voucher_contra?.[i]?.nature?.label == "Dr" ? "credit" : "debit"
    const chkDataOtrName =
      data?.voucher_contra?.[i]?.nature?.label == "Dr" ? "debit" : "credit"

    const currAmount = chkDataName == data?.voucher_contra?.[i]

    console.log(`currAmount`, chkDataName, chkDataOtrName)

    const chkAmount = data?.voucher_contra.reduce(
      (sum, item) => sum + parseFloat(item?.[chkDataName] || 0),
      0
    )
    const chkSameAmount = data?.voucher_contra.reduce(
      (sum, item) => sum + parseFloat(item?.[chkDataOtrName] || 0),
      0
    )

    const currAmt = data?.voucher_contra?.[i]?.[chkDataOtrName]

    console.log(`chkSameAmount`, chkSameAmount, currAmt)

    const totalAmount = data?.voucher_contra_partial_pay?.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0
    )

    console.log(`ChkModal`, i, chkAmount, totalAmount)
    if (i != 0 && Number(currAmt) < Number(totalAmount)) {
      toastError(`Amount cannot be greater than ${currAmt}`)
      return
    } else if (i != 0 && Number(currAmt) > Number(totalAmount)) {
      // if (Number(chkAmount) > Number(totalAmount)) {
      contraPartialListAppend({
        account_id: data?.credit_id?.value,
        debit: 0,
        credit: 0,
        chk: viewData?.currIndex,
        code: watch("code"),
        // incrementCode(
        //   data?.voucher_contra_partial_pay[
        //     data?.voucher_contra_partial_pay?.length - 1
        //   ]?.code
        //     ? data?.voucher_contra_partial_pay[
        //         data?.voucher_contra_partial_pay?.length - 1
        //       ]?.code
        //     : watch("code")
        // ),
        // code: incrementCode(
        //   data?.voucher_contra_partial_pay[
        //     data?.voucher_contra_partial_pay?.length - 1
        //   ]?.code
        //     ? data?.voucher_contra_partial_pay[
        //         data?.voucher_contra_partial_pay?.length - 1
        //       ]?.code
        //     : watch("code")
        // ),
        amount: Number(Number(currAmt) - Number(totalAmount)).toFixed(
          desimalrange
        ),
        nature: data?.voucher_contra[i]?.nature,
        date: moment(now, "DD-MM-MMMM").toDate(),
        ref_id: {
          label: "New Ref",
          value: 3,
        },
      })
      return
      // }
    }

    if (!data?.voucher_contra?.[i]) {
      console.error(`Invalid index: ${i}`)
      return
    }

    // Replace partial_payments with the new array
    // const filtered = Array.isArray(data.voucher_contra_partial_pay)
    //   ? data.voucher_contra_partial_pay
    //   :
    //     []

    const filteredRaw = Array.isArray(data.voucher_contra_partial_pay)
      ? data.voucher_contra_partial_pay
      : []

    const mergeSameVoucherIds = arr => {
      const grouped = {}
      const result = []

      arr.forEach(item => {
        const vid = item.voucher_id
        if (vid !== undefined && vid !== null) {
          if (!grouped[vid]) {
            grouped[vid] = { ...item, amount: parseFloat(item.amount) }
          } else {
            grouped[vid].amount += parseFloat(item.amount)
          }
        } else {
          result.push(item)
        }
      })

      const merged = Object.values(grouped).map(item => ({
        ...item,
        amount: Number(item.amount).toFixed(desimalrange),
      }))

      return [...result, ...merged]
    }

    const filtered = mergeSameVoucherIds(filteredRaw)

    console.log(`filtered`, filtered)

    data.voucher_contra[i].partial_payments = filtered

    const totalamount = filtered.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0
    )

    const updatedData = {
      ...data,
      voucher_contra: data.voucher_contra.map((item, idx) => {
        if (idx === i) {
          const updatedItem = { ...item, partial_payments: filtered }
          console.log("Updating index:", idx, "with item:", updatedItem)
          return updatedItem
        }
        return item
      }),
    }

    reset(updatedData)

    // Reset the form with the updated data
    // reset({
    //   ...data,
    //   voucher_contra: data.voucher_contra.map((item, idx) =>
    //     idx === i ? { ...item, partial_payments: filtered } : item
    //   ),
    // })

    console.log(`updatedData`, updatedData)

    setValue(
      `voucher_contra.${i}.${
        data?.voucher_contra?.[i]?.nature?.value == "debit" ? "debit" : "credit"
      }`,
      totalamount
    )
    setValue(
      `voucher_contra.${i}.${
        data?.voucher_contra?.[i]?.nature?.value == "debit" ? "credit" : "debit"
      }`,
      0
    )

    setModal(false)
    handleAppendContraRow()
  }

  const handleBankModalData = i => {
    const dataVal = getValues()

    setValue(`voucher_contra.${i}.date`, dataVal?.bank_date)
    setValue(`voucher_contra.${i}.instrument_no`, dataVal?.instrument_no)
    setValue(`voucher_contra.${i}.instrument_date`, dataVal?.instrument_date)
    setValue(`voucher_contra.${i}.currency`, dataVal?.currency)
    setValue(`voucher_contra.${i}.bank_amount`, dataVal?.bank_amount)
    setValue(`voucher_contra.${i}.remarks`, dataVal?.remarks)
    setValue(`voucher_contra.${i}.payment_type_id`, dataVal?.payment_type_id)
    setValue(`voucher_contra.${i}.is_pdc`, pdcCheck ? 1 : 0)
    setValue(
      `${
        watch(`voucher_contra.${i}.nature`)?.value == "debit"
          ? `voucher_contra.${i}.debit`
          : `voucher_contra.${i}.credit`
      }`,
      dataVal?.bank_amount
    )
    setValue(
      `${
        watch(`voucher_contra.${i}.nature`)?.value == "debit"
          ? `voucher_contra.${i}.credit`
          : `voucher_contra.${i}.debit`
      }`,
      0
    )
    setBankModal(false)
  }

  const handleCCModalData = i => {
    const dataVal = getValues()

    setValue(
      rSelected == 3
        ? `voucher_sales_acc.${i}.cost_center_id`
        : `voucher_contra.${i}.cost_center_id`,
      dataVal?.cost_center_id
    )
    setValue(
      rSelected == 3
        ? `voucher_sales_acc.${i}.transaction_type`
        : `voucher_contra.${i}.transaction_type`,
      dataVal?.transaction_type
    )
    setCCModal(false)
  }

  console.log(`chk value test`, watch(`voucher_contra.0`))

  const incrementCode = code => {
    if (!code) return "1"

    const prefixMatch = code.match(/[A-Za-z]+/)
    const numberMatch = code.match(/\d+/)

    const prefix = prefixMatch ? prefixMatch[0] : ""
    const number = numberMatch ? numberMatch[0] : "0"

    const incremented = String(Number(number) + 1).padStart(
      number.length || 1,
      "0"
    )

    return prefix + incremented
  }

  const onKeyDown = event => {
    console.log(`event.key`, event)

    const targetName = event.target.name

    const isTargetField =
      /^voucher_contra\.\d+\.(debit|credit)$/.test(targetName) ||
      /^voucher_contra_partial_pay\.\d+\.amount$/.test(targetName) ||
      /^voucher_sales_acc\.\d+\.(rate|amount)$/.test(targetName)

    if (!isTargetField) return

    const voucherId = watch("voucher_id")?.value
    const modalVoucherIds = [1, 3, 6, 8, 21]
    const conditionalVoucherIds = [13, 15]
    if (event.key === "Tab") {
      if (
        modal &&
        conditionalVoucherIds.includes(voucherId) &&
        [1, 3].includes(rSelected)
      ) {
        event.preventDefault()
        handleSubmit(handleRegistration)()
      } else if (
        modal &&
        (modalVoucherIds.includes(voucherId) ||
          (conditionalVoucherIds.includes(voucherId) && rSelected === 2))
      ) {
        event.preventDefault()
        handleModalData(viewData?.currIndex)
      } else if (
        !modal &&
        (modalVoucherIds.includes(voucherId) ||
          (conditionalVoucherIds.includes(voucherId) && rSelected === 2) ||
          ([4, 18].includes(watch("voucher_id")?.value) && rSelected === 2))
      ) {
        event.preventDefault()
        // handleModalData(viewData?.currIndex);
        handleAppendContraRow()
      } else if (
        [13, 15, 4, 18].includes(voucherId) &&
        rSelected == 3 &&
        !modal
      ) {
        event.preventDefault()
        handleAppendSaleAccRow()
      }
    }
  }

  const watchVoucherId = watch("voucher_id")?.value

  //   useEffect(() => {
  //     if (
  //       watch("voucher_id")?.value == 1 ||
  //       watch("voucher_id")?.value == 3 ||
  //       watch("voucher_id")?.value == 6 ||
  //       watch("voucher_id")?.value == 8 ||
  //       watch("voucher_id")?.value == 21 ||
  //       (watch("voucher_id")?.value == 13 && rSelected == 2) ||
  //       rSelected == 3 ||
  //       (watch("voucher_id")?.value == 15 && rSelected == 2)
  //     ) {
  //       window.addEventListener("keydown", onKeyDown)
  //       return () => window.removeEventListener("keydown", onKeyDown)
  //     } else if (
  //       modal &&
  //       (watch("voucher_id")?.value == 13 || watch("voucher_id")?.value == 15) &&
  //       rSelected == 1
  //     ) {
  //       window.addEventListener("keydown", onKeyDown)
  //       return () => window.removeEventListener("keydown", onKeyDown)
  //     }
  //   }, [modal, watchVoucherId, rSelected])

  const handleRegistration = async data => {
    console.log(`handleRegistration data :`, data)
    const generalTerms = data?.general_terms
      ? draftToHtml(convertToRaw(data?.general_terms?.getCurrentContent()))
      : ""
    const deliveryTerms = data?.delivery_terms
      ? draftToHtml(convertToRaw(data?.delivery_terms?.getCurrentContent()))
      : ""
    const reducedChkVal = data?.voucher_sales_acc?.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0
    )
    if (
      [13, 15].includes(data?.voucher_id?.value) &&
      [1, 3, 4].includes(rSelected) &&
      !modal
    ) {
      const removeIds = data?.voucher_contra_partial_pay?.map((item, i) => i)
      console.log(`removeIds`, removeIds)

      contraPartialListRemove([removeIds])
      setViewData({
        voucher_type: data?.voucher_id?.value,
        ledger_id: data?.credit_id?.value,
        currIndex: 0,
      })
      setModal(true)
      setValue(
        `voucher_contra_partial_pay.${0}.amount`,
        data?.voucher_id?.value == 13 && rSelected == 1
          ? calculationSale("total_amount")
          : [13, 15].includes(data?.voucher_id?.value) && rSelected == 3
          ? reducedChkVal
          : calculation("total_amount")
      )
      setValue(
        `voucher_contra_partial_pay.${0}.code`,
        data?.ref_code ? data?.ref_code : data?.code
      )
      setValue(
        `voucher_contra_partial_pay.${0}.date`,
        data?.voucher_id?.value == 15 && rSelected == 1
          ? data?.ref_date
          : moment(now, "DD-MM-MMMM").toDate()
      )
      setValue(
        `voucher_contra_partial_pay.${0}.nature`,
        data?.voucher_id?.value == 13
          ? { label: "Dr", value: "debit" }
          : { label: "Cr", value: "credit" }
      )
      setValue(`voucher_contra_partial_pay.${0}.ref_id`, {
        label: "New Ref",
        value: 3,
      })
    } else {
      const calcuChkTotal =
        data?.voucher_id?.value == 13 && rSelected == 1
          ? calculationSale("total_amount")
          : [13, 15].includes(data?.voucher_id?.value) && rSelected == 3
          ? reducedChkVal
          : calculation("total_amount")
      const totalAmount = data?.voucher_contra_partial_pay?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0
      )
      if (
        Number(totalAmount) > Number(calcuChkTotal) &&
        [13, 15].includes(data?.voucher_id?.value) &&
        !editId &&
        [1, 3, 4].includes(rSelected)
      ) {
        toastError(`Amount cannot be greater than ${calcuChkTotal}`)
        return
      } else if (
        Number(totalAmount) < Number(calcuChkTotal) &&
        [13, 15].includes(data?.voucher_id?.value) &&
        !editId &&
        [1, 3, 4].includes(rSelected)
      ) {
        toastError("Amount not equal")
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          chk: viewData?.currIndex,
          code: incrementCode(
            data?.voucher_contra_partial_pay[
              data?.voucher_contra_partial_pay?.length - 1
            ]?.code
              ? data?.voucher_contra_partial_pay[
                  data?.voucher_contra_partial_pay?.length - 1
                ]?.code
              : watch("code")
          ),
          amount: Number(Number(calcuChkTotal) - Number(totalAmount)).toFixed(
            desimalrange
          ),
          nature:
            data?.voucher_id?.value == 13
              ? { label: "Dr", value: "debit" }
              : { label: "Cr", value: "credit" },
          date: moment(now, "DD-MM-MMMM").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
        return
      }

      console.log(`totalAmount`, totalAmount, calcuChkTotal)
      let productArray = []
      let valueArray = []
      let partialPaymentArr = []

      if (data?.voucher_id?.value === 3) {
        const validGroups = [5, 6]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "credit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "For this voucher, at least one credit entry must belong to a Bank or Cash account group."
          )
          return false
        }
      } else if (data?.voucher_id?.value == 6) {
        const validGroups = [5, 6]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "debit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "For this voucher, at least one debit entry must belong to a Bank or Cash account group."
          )
          return false
        }
      } else if (data?.voucher_id?.value == 15 && rSelected == 2) {
        const validGroups = [27, 29]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "debit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "Please select either Purchase Account or Direct Expence in one entries."
          )
          return false
        }
      } else if (data?.voucher_id?.value == 15 && rSelected == 3) {
        const validGroups = [27, 29]
        const isValid = data?.voucher_sales_acc?.some(item => {
          const groupId = item?.account_id?.account_group_id
          // const nature = item?.nature?.value
          return validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "Please select either Purchase Account or Direct Expence in one entries."
          )
          return false
        }
      } else if (data?.voucher_id?.value == 13 && rSelected == 2) {
        const validGroups = [26, 24]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "credit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "Please select either Sales Account or Direct Income in one entries."
          )
          return false
        }
      } else if (data?.voucher_id?.value == 13 && rSelected == 3) {
        const validGroups = [26, 24]
        const isValid = data?.voucher_sales_acc?.some(item => {
          const groupId = item?.account_id?.account_group_id
          // const nature = item?.nature?.value
          return validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "Please select either Sales Account or Direct Income in one entries."
          )
          return false
        }
      }

      if (data?.voucher_id?.value == 16) {
        productArray = data?.voucher_materials?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          requested_quantity: e?.requested_quantity,
          unit_price: e?.unit_price,
        }))
      }

      const subTotal =
        [13, 18].includes(data?.voucher_id?.value) && rSelected == 1
          ? calculationSale("total_amount")
          : data?.voucher_id?.value == 15
          ? calculation("total_amount")
          : data?.voucher_id?.value == 13 && rSelected == 4
          ? calculation("total_amount")
          : data?.sub_total

      try {
        setIsLoading(true)
        const update = await postFinanceVoucher(
          {
            ...(productArray?.length && { product_list: productArray }),
            ...(valueArray?.length && { entries: valueArray }),
            ...(data?.sub_total && {
              sub_total: subTotal,
            }),
            ...(data?.sub_total == "" &&
              data?.sale_total && { sub_total: data?.sale_total }),
            ...([13, 18].includes(data?.voucher_id?.value) &&
              rSelected == 1 && { sale_total: data?.sale_total }),
            ...(data?.voucher_id?.value == 15 && {
              sub_total: calculation("total_amount"),
            }),
            inv_num: data?.inv_num?.value,
            ...(data?.inv_date && {
              inv_date: moment(data?.inv_date).format("YYYY-MM-DD"),
            }),
            // ...((data?.voucher_id?.value == 15 ||
            //   data?.voucher_id?.value == 13) && {
            voucher_invoice:
              [15, 4].includes(data?.voucher_id?.value) && rSelected == 1
                ? "Purchase Invoice"
                : [15, 4].includes(data?.voucher_id?.value) && rSelected == 2
                ? "Purchase Voucher"
                : [13, 18].includes(data?.voucher_id?.value) && rSelected == 1
                ? "Sales Invoice"
                : [13, 18].includes(data?.voucher_id?.value) && rSelected == 2
                ? "Sales Voucher"
                : [13, 18].includes(data?.voucher_id?.value) && rSelected == 3
                ? "Sales Account"
                : [15, 4].includes(data?.voucher_id?.value) && rSelected == 3
                ? "Purchase Account"
                : [13, 18].includes(data?.voucher_id?.value) && rSelected == 4
                ? "Sales Product Invoice"
                : "",
            // }),
            ...(partialPaymentArr?.length && {
              partial_payments: partialPaymentArr,
            }),
            code: data?.code,
            sup_cont_per_id: data?.sup_cont_per_id?.value,
            material_requisition_id: data?.material_requisition_id?.value,
            material_request_id: data?.material_request_id?.id
              ? data?.material_request_id?.id
              : data?.material_request_id?.value
              ? data?.material_request_id?.value
              : data?.material_request_id,
            rfq_id: data?.rfq_id?.value,
            purchase_order_id: data?.purchase_order_id?.value
              ? data?.purchase_order_id?.value
              : data?.purchase_order_id,
            // project_id: data?.project_code?.value,
            address: data?.address,
            date: moment(data?.po_date).format("YYYY-MM-DD"),
            exp_Delivery_date: moment(data?.exp_Delivery_date).format(
              "YYYY-MM-DD"
            ),
            project_id: projectId
              ? projectId
              : data?.credit_id?.project_id
              ? data?.credit_id?.project_id
              : data?.debit_id?.project_id
              ? data?.debit_id?.project_id
              : data?.project_code?.value
              ? data?.project_code?.value
              : data?.project_id,
            voucher_id: data?.voucher_id?.value,
            // credit_id:data?.credit_id?.value,
            // debit_id: data?.debit_id?.value,
            credit_id:
              data?.voucher_id?.value == 13
                ? data?.debit_id?.value
                : data?.credit_id?.value,
            debit_id:
              data?.voucher_id?.value == 13
                ? data?.credit_id?.value
                : data?.debit_id?.value,
            voucher_type: data?.voucher_id?.voucher_type,
            date: moment(data?.po_date).format("YYYY-MM-DD"),
            narration: data?.narration,
            discount: !discountCheck ? 0 : data?.discount ? data?.discount : 0,
            vat_charge:
              vatCheck && watch("vat_id")?.vat_per
                ? watch("vat_id")?.vat_per
                : vatCheck && watch("vat_id")?.vat_per == null
                ? loggedUser?.settings?.tax
                : 0,
            shipping_charge: shippingCheck ? data?.shipping_charge : 0,
            other_charge: othersCheck ? data?.other_charge : 0,
            retention: retentionCheck ? data?.retention : 0,
            ...(data?.project_id && { project_id: data?.project_id }),
            // ...(data?.project_ids && { project_id: data?.project_ids?.value }),
            manufacturing_journal_id: data?.manufacturing_journal_id?.value,
            ...(editId && { id: editId }),
            general_terms: generalTerms,
            delivery_terms: deliveryTerms,
          },
          progressEvent => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            // setProgress(percentCompleted);
            console.log(`percentCompleted`, percentCompleted)
          }
        )
        if (fromDashboard) {
          toastSuccess(update?.message)
          toggle()
        } else {
          toastSuccess(update?.message)
          // navigate("/finance-voucher")
          navigate(
            location?.state?.type === "from_po"
              ? "/procurement-purchaseorder"
              : editId
              ? "/finance-voucher"
              : "/finance-voucher/add"
          )
          getUniqueCode(
            "ref_number",
            "VoucherEntry",
            `Voucher - ${ucfirst(data?.voucher_id?.voucher_type)}`
          )
          setModal(false)
          setVatCheck(false)
          setRetentionCheck(false)
          setAdvRetentionCheck(false)
          setShippingCheck(false)
          setOthersCheck(false)
          setDiscountCheck(false)
          setPrintID(update?.voucher?.id)
          setConfirmModal(true)

          reset({
            po_date: data?.po_date,
            voucher_id: data?.voucher_id,
            manufacturing_journal_id: null,
            material_requisition_id: null,
            purchase_order_id_ref: null,
            project_ids: null,
            inv_num: null,
            voucher_contra: [
              {
                nature: null,
                debit_amount: 0,
                credit_amount: 0,
                account_group_id: null,
              },
            ],
            voucher_materials: [
              {
                qnt: "",
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_purchase: [
              {
                qnt: "",
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_materialout: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
                amount: 0,
              },
            ],
            voucher_destination: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
                amount: 0,
              },
            ],
            voucher_source: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_sales_acc: [
              {
                amount: 0,
                rate: "",
                account_id: null,
              },
            ],
            credit_id: null,
            debit_id: null,
          })
          console.log(`update`, update, data)
        }
        // dispatch(changeSidebarSize("lg"))
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
      }
    }
  }
  const handlePoChange = () => {
    const { po_id } = getValues()
    fetchPotData(po_id?.value)
    setIdPO(po_id?.value)
  }

  const handleVoucherType = e => {
    console.log("handleVoucherType :", e)
    reset({
      voucher_id: {
        label: e?.label,
        value: e?.value,
        voucher_type: e?.voucher_type,
      },
    })
  }

  const handleRateChange = (e, i) => {
    const dataVal = getValues()
    const mainVal = dataVal?.voucher_sales_acc?.[0]?.amount
    console.log(`mainVal`, mainVal)
    const calculatedVal = (Number(e) / 100) * Number(mainVal)
    const chkDutiesGroup = watch(
      `voucher_sales_acc.${i}.account_id`
    )?.account_group_id

    console.log(`chkDutiesGroup`, dataVal)

    if (chkDutiesGroup == 17) {
      const vatPer = watch(`voucher_sales_acc.${i}.account_id`)?.vat_per || 0
      const vatCheckType = watch(`voucher_sales_acc.${i}.account_id`)?.vat_cal
      console.log(`vatCheckType`, vatCheckType)

      const reducedVal = dataVal?.voucher_sales_acc.reduce(
        (sum, item, index) => {
          if (index === i) return sum // Skip current index
          return sum + parseFloat(item.amount || 0)
        },
        0
      )

      console.log()

      setValue(
        `voucher_sales_acc.${i}.amount`,
        (
          (Number(e) / 100) *
          Number(vatCheckType == 2 ? Number(reducedVal) : Number(mainVal))
        ).toFixed(2) || 0
      )
    } else {
      setValue(
        `voucher_sales_acc.${i}.amount`,
        Number(calculatedVal || 0).toFixed(2)
      )
    }
    console.log(`calculatedVal`, calculatedVal, e)
  }

  // const handleAppendContraRow = () => {
  //   const paymentValues = getValues()
  //   const lastIndex = paymentValues?.voucher_contra?.length - 1
  //   const mappingData = paymentValues?.voucher_contra
  //   const setData = "voucher_contra"

  //   const { totalDebit, totalCredit } = mappingData?.reduce(
  //     (totals, entry) => {
  //       const debit = parseFloat(entry.debit || 0)
  //       const credit = parseFloat(entry.credit || 0)
  //       return {
  //         totalDebit: totals.totalDebit + debit,
  //         totalCredit: totals.totalCredit + credit,
  //       }
  //     },
  //     { totalDebit: 0, totalCredit: 0 }
  //   )

  //   contraListAppend({
  //     nature:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "debit"
  //         ? { label: "Cr", value: "credit" }
  //         : { label: "Dr", value: "debit" },
  //     account_id: null,
  //     debit:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "debit"
  //         ? totalDebit
  //         : 0,
  //     credit:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "credit"
  //         ? totalCredit
  //         : 0,
  //   })
  // }

  const handleAppendContraRow = () => {
    const paymentValues = getValues()
    const mappingData = paymentValues?.voucher_contra || []
    const lastIndex = mappingData.length - 1 // Fix: Get correct last item index

    const { totalDebit, totalCredit } = mappingData.reduce(
      (totals, entry) => {
        const debit = parseFloat(entry.debit || 0)
        const credit = parseFloat(entry.credit || 0)
        return {
          totalDebit: totals.totalDebit + debit,
          totalCredit: totals.totalCredit + credit,
        }
      },
      { totalDebit: 0, totalCredit: 0 }
    )

    if (totalDebit && totalCredit && totalDebit === totalCredit) {
      // handleSubmit(handleRegistration)()
      return
    }

    const newIndex = mappingData.length

    const lastNature = mappingData?.[lastIndex]?.nature?.value

    const newNature =
      lastNature == "debit"
        ? { label: "Cr", value: "credit" }
        : { label: "Dr", value: "debit" }

    console.log(`lastNature`, totalCredit, totalDebit)

    contraListAppend({
      nature:
        Number(totalCredit) > Number(totalDebit)
          ? { label: "Dr", value: "debit" }
          : { label: "Cr", value: "credit" },
      account_id: null,
      debit:
        Number(totalCredit) > Number(totalDebit)
          ? (Number(totalCredit) - Number(totalDebit)).toFixed(
              desimalrange || 2
            )
          : 0,
      credit:
        Number(totalDebit) > Number(totalCredit)
          ? (Number(totalDebit) - Number(totalCredit)).toFixed(
              desimalrange || 2
            )
          : 0,
    })
    setTimeout(() => {
      const newIndex = mappingData.length // newly added row
      natureRefs.current[newIndex]?.focus() // Focus react-select input
    }, 50)
  }

  const handleAppendSaleAccRow = () => {
    salesAccAppend({
      amount: 0,
      rate: "",
      account_id: null,
    })
  }

  const handleRefAgainst = (e, i) => {
    setViewVouchersLi(e?.value == 2 ? true : false)
    setContraId(i)
  }

  const handleType = (e, i) => {
    console.log(`handleType`, e, i)

    // if (e?.account_group_id == 13 || e?.account_group_id == 22) {
    if (e?.is_bill_wise == 1) {
      const removeIds = watch("voucher_contra_partial_pay")?.map((item, i) => i)
      removeIds &&
        removeIds?.length > 1 &&
        removeIds?.map(i => contraPartialListRemove(i))
      const credtDays = e?.creditperiod?.value
      setViewData({
        voucher_type: e?.account_group_id == 13 ? 13 : 15,
        ledger_id: e?.id,
        currIndex: i,
      })
      setValue(`voucher_contra_partial_pay.${0}.chk`, i)
      setValue(
        `voucher_contra_partial_pay.${0}.amount`,
        watch(`voucher_contra.${i}.debit`) != 0
          ? watch(`voucher_contra.${i}.debit`)
          : watch(`voucher_contra.${i}.credit`)
      )
      setValue(
        `voucher_contra_partial_pay.${0}.code`,
        watch("ref_code") ? watch("ref_code") : watch("code")
      )
      setValue(
        `voucher_contra_partial_pay.${0}.nature`,
        watch(`voucher_contra.${i}.nature`)
        //   {
        //   label: "Dr",
        //   value: "debit",
        // }
      )
      setValue(`voucher_contra_partial_pay.${0}.ref_id`, {
        label: "New Ref",
        value: 3,
      })
      setValue(
        `voucher_contra_partial_pay.${0}.date`,
        credtDays
          ? moment().add(credtDays, "days").toDate()
          : moment(now).toDate()
      )

      setModal(true)
    } else if (
      [24, 25, 27, 28]?.includes(Number(e?.account_group_id)) ||
      [24, 25, 27, 28]?.some(item =>
        e?.account_group?.parent_ids?.includes(item)
      )
    ) {
      setViewData({
        voucher_type: e?.account_group_id,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
        showCC: true,
      })
      setValue("cost_center_id", null)
      setCCModal(true)
    } else if (e?.is_vat_applicable == 1) {
      console.log(`hi is_vat_applicable`, e)
      setViewData({
        voucher_type: e?.account_group_id == 13 ? 13 : 15,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
      })
      setValue(
        `transaction_type`,
        e?.nature_of_transaction?.id
          ? {
              value: e?.nature_of_transaction?.id,
              label: e?.nature_of_transaction?.label,
            }
          : null
      )
      // setTransactionModal(true)
      setValue("cost_center_id", null)
      setCCModal(true)
    } else if (e?.account_group_id == 17) {
      const paymentValues = getValues()
      const mappingData = paymentValues?.voucher_contra
      const setData = "voucher_contra"
      const vatPer =
        e?.vat_per != null ? e?.vat_per : loggedUser?.settings?.tax || 0
      const dataSide = watch(`voucher_contra.${i}.nature`)?.value

      console.log(`mappingData`, mappingData)

      const { totalDebit, totalCredit } = mappingData?.reduce(
        (totals, entry, index) => {
          const vatApplicableChk = Number(entry?.account_id?.is_vat_applicable)
          const groupId = entry?.account_id?.account_group_id
          console.log(
            `vatApppp`,
            index == i,
            ![13, 22].includes(Number(groupId)),
            vatApplicableChk !== 1
          )

          if (index == i) return totals

          console.log(`entry chk`, entry, totals, index)

          const debit = parseFloat(entry.debit || 0)
          const credit = parseFloat(entry.credit || 0)
          return {
            totalDebit: totals.totalDebit + debit,
            totalCredit: totals.totalCredit + credit,
          }
        },
        { totalDebit: 0, totalCredit: 0 }
      )

      const vatCalMethod = e?.vat_cal

      const valueCal =
        dataSide === "debit" && vatCalMethod == 2
          ? totalDebit - totalCredit
          : dataSide === "credit" && vatCalMethod == 2
          ? totalCredit - totalDebit
          : dataSide === "debit" && vatCalMethod == 1
          ? totalDebit
          : dataSide === "credit" && vatCalMethod == 1
          ? totalCredit
          : 0

      const currPerVal = (Number(vatPer) / 100) * Math.abs(Number(valueCal))
      console.log(
        `vatCalMethod`,
        vatCalMethod,
        totalDebit,
        totalCredit,
        currPerVal,
        valueCal
      )

      setValue(
        `voucher_contra.${i}.${dataSide}`,
        Number(currPerVal).toFixed(desimalrange)
      )
    } else {
      // setValue(`voucher_contra.${i}.debit`, 0)
      // setValue(`voucher_contra.${i}.credit`, 0)
      setValue(`voucher_contra.${i}.partial_payments`, [])
    }

    if (e?.account_group_id == 5) {
      setViewData({
        voucher_type: e?.account_group_id,
        ledger_id: e?.id,
        currIndex: i,
        ...(e?.is_vat_applicable == 1 && { taxChk: e?.is_vat_applicable }),
      })
      setValue(`bank_date`, watch("po_date"))
      setValue(
        `bank_amount`,
        watch(`voucher_contra.${i}.credit`)
          ? watch(`voucher_contra.${i}.credit`)
          : watch(`voucher_contra.${i}.debit`)
          ? watch(`voucher_contra.${i}.debit`)
          : 0
      )
      setBankModal(true)
    }
  }

  const fetchRfqData = async id => {
    const response = await fetchRfqReference(id)
    const materialsArr = response?.items?.map((dt, i) => ({
      product_id: {
        label: dt?.product?.product_code,
        value: dt?.product?.id,
      },
      description: dt?.product?.description,
      qnt: dt?.quantity,
      unit_price: dt?.price ? dt?.price : 0,
      sub_price: Number(dt?.quantity || 0) * Number(dt?.price || 0),
      unit: {
        label: dt?.product?.unit?.unit_code,
        value: dt?.product?.unit_code?.id,
      },
    }))
    const data = getValues()
    reset({
      ...data,
      rfq_ref_code: response?.ref_code,
      material_request_id: response?.material_request_ids,
      rfq_id: {
        label: response?.code,
        value: response?.id,
      },
      credit_id: {
        label: response?.vendor?.name
          ? response?.vendor?.name
          : response?.vendor?.ledger?.name,
        value: response?.vendor?.ledger_id
          ? response?.vendor?.ledger_id
          : response?.vendor?.ledger_id,
      },
      request_date: response?.created_at,
      voucher_materials: materialsArr,
    })
  }

  const fetchMaterialRequstiotion = async id => {
    const responce = await fetchMRRequesting(id)
    const materialArr = responce?.data?.items?.map((dt, i) => ({
      material_id: {
        label: dt?.material?.product_code,
        value: dt?.material?.id,
        ...dt?.material,
      },
      description: dt?.material?.description,
      store: dt?.storeCount,
      qnt: dt?.quantity,
      rate: dt?.material?.price_aed,
      amount: Number(dt?.quantity || 0) * Number(dt?.material?.price_aed || 0),
      // bal_qnt: dt?.storeCount - dt?.quantity,
      id: dt?.id,
    }))
    setProjectID(responce?.data?.project?.id)
    const oldValue = getValues()
    reset({
      ...oldValue,
      voucher_source: materialArr,
      project_code: {
        label: location?.state?.project?.project_code,
        value: location?.state?.project?.id,
      },
    })
  }
  const fetchPotData = async idData => {
    const response = await fetchPurchase(idData)
    setResponseData(response?.data)
    if (idData == response.data?.id) {
      const arrayData = response.data?.purchaseorder_lists?.map(dt => {
        const TotalReceivedQty = dt.grnlist.reduce(
          (total, grnqty) => total + parseFloat(grnqty.received_quantity),
          0
        )

        const alreadyReceived = dt.grnlist.length
          ? dt.quantity - TotalReceivedQty
          : 0
        const Received = dt.grnlist.length ? alreadyReceived : dt.quantity

        return {
          product_code: dt?.product_code && {
            label: dt?.product_code.product_code,
            value: dt?.product_code.id,
          },
          description: dt.description,
          ordered_quantity: dt?.quantity,
          received_quantity: dt?.quantity - Received,
          pending_quantity: Received,
          unit: {
            value: dt?.unit?.id,
            label: dt?.unit?.unit_code,
          },
        }
      })

      const previousDatas = getValues()
      reset({
        ...previousDatas,
        project_id: response.data?.project_id,
        grnproductlist: arrayData,
      })
    }
  }

  const handleCompanyProduct = (e, index) => {
    setValue(`voucher_materials.${index}.description`, e?.description)
    setValue(`voucher_materials.${index}.unit`, {
      label: e?.unit?.unit_code,
      value: e?.unit?.id,
    })
    setValue(`voucher_materials.${index}.unit_price`, e?.price_aed)
  }

  const handleSubPrice = (e, i) => {
    const singlePrice = watch(`voucher_materials.${i}.unit_price`)
    const subPrice =
      Number(watch(`voucher_materials.${i}.qnt`)) * Number(singlePrice)
    setValue(`voucher_materials.${i}.sub_price`, subPrice)
  }

  const handlePDCCheck = dt => {
    setPdcCheck(!dt)
  }
  const handleBankModalClose = () => {
    setBankModal(false)
    setPdcCheck(false)
  }

  useEffect(() => {
    if (retentionCheck) {
      const retentionPercent = watch("retention_amount") || 0
      const projectTotal = watch("sale_total") || 0
      const retentionAmount =
        (Number(projectTotal) * Number(retentionPercent)) / 100
      setValue("retention", Number(retentionAmount).toFixed(desimalrange))
    }
    if (advRetentionCheck) {
      const advretentionPercent = watch("adv_retention_amount") || 0
      const projectTotal = watch("sale_total") || 0
      const advretentionAmount =
        (Number(projectTotal) * Number(advretentionPercent)) / 100
      setValue(
        "adv_retention",
        Number(advretentionAmount).toFixed(desimalrange)
      )
    }
  }, [watch("sale_total")])

  const calculation = type => {
    const productWatch =
      watch(
        [15, 4].includes(watch(`voucher_id`)?.value)
          ? "voucher_purchase"
          : "voucher_materials"
      ) || []

    // const taxWatch =
    //   vatCheck && watch("vat_id")?.vat_per == null
    //     ? Number(loggedUser?.settings?.tax)
    //     : vatCheck && watch("vat_id")?.vat_per != null
    //     ? Number(watch("vat_id")?.vat_per)
    //     : 0

    const taxWatch =
      vatCheck && watch("vat_amount")
        ? Number(watch("vat_amount"))
        : vatCheck && watch("vat_id")?.vat_per != null
        ? Number(watch("vat_id")?.vat_per)
        : 0

    const discountWatch = Number(watch("discount")) || 0
    const otherChargeWatch = Number(watch("other_charge")) || 0
    const shippingChargeWatch = Number(watch("shipping_charge")) || 0

    switch (type) {
      case "price": {
        const price =
          productWatch?.reduce((a, b) => Number(b.unit_price) + a, 0) || 0
        return Number(price)?.toFixed(desimalrange)
      }
      case "quantity": {
        return productWatch?.reduce((a, b) => Number(b.qnt) + a, 0)
      }
      case "sub_total": {
        const products = productWatch || [] // Ensure productWatch is an array
        const subTotal = products.reduce((acc, product) => {
          const price = Number(product.unit_price)
          const quantity = Number(product.qnt)
          const rowTotal = price * quantity
          return acc + rowTotal
        }, 0)
        setValue(`sub_total`, Number(subTotal)?.toFixed(desimalrange))
        return Number(subTotal)?.toFixed(desimalrange)
      }
      case "discounted_amount": {
        const subTotal = calculation("sub_total")
        const discountedAmount = subTotal - (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "discounted_amount_send": {
        const subTotal = calculation("sub_total")
        const discountedAmount = (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "tax_total": {
        const baseAmount = discountCheck
          ? calculation("discounted_amount")
          : calculation("sub_total")

        const totalBeforeTax =
          Number(baseAmount) +
          Number(otherChargeWatch) +
          Number(shippingChargeWatch)
        const taxAmount = (totalBeforeTax * taxWatch) / 100
        return Number(taxAmount)?.toFixed(desimalrange)
      }
      case "total_amount": {
        const baseAmount = discountCheck
          ? calculation("discounted_amount")
          : calculation("sub_total")

        const totalBeforeTax =
          Number(baseAmount) +
          Number(otherChargeWatch) +
          Number(shippingChargeWatch)

        const taxAmount = (totalBeforeTax * taxWatch) / 100
        const totalAmount = Number(totalBeforeTax) + Number(taxAmount)
        setValue(`net_total`, Number(totalAmount)?.toFixed(desimalrange))
        return Number(totalAmount)?.toFixed(desimalrange)
      }

      default:
        return 0
    }
  }

  useEffect(() => {
    const subValues = getValues()

    if (
      subValues?.voucher_id?.value == 13 &&
      watch("manufacturing_journal_id")?.value &&
      !id
    ) {
      const subTotal = subValues?.sale_total
      const projectProfit =
        Number(
          subValues?.project_ids?.estimation_revision?.estimation
            ?.margin_percentage
        ) != 0
          ? Number(
              subValues?.project_ids?.estimation_revision?.estimation
                ?.margin_percentage
            )
          : Number(
              subValues?.project_ids?.estimation_revision?.estimation
                ?.margin_value
            ) != 0
          ? Number(
              (Number(
                subValues?.project_ids?.estimation_revision?.estimation
                  ?.margin_value
              ) /
                Number(
                  subValues?.project_ids?.estimation_revision?.estimation
                    ?.amount
                ) -
                Number(
                  subValues?.project_ids?.estimation_revision?.estimation
                    ?.margin_value
                )) *
                100
            ).toFixed(desimalrange)
          : 0

      const totalSumAmt =
        Number(subTotal) + (Number(subTotal) * projectProfit) / 100

      setValue(
        "sub_total",
        subValues?.voucher_id?.value == 13 ? subTotal : totalSumAmt
      )
    }
  }, [watch("sale_total"), watch("manufacturing_journal_id")?.value])

  const calculationSale = type => {
    const salePriceWatch = watch("sale_total")
    console.log(`salePriceWatch`, salePriceWatch)

    const taxWatch =
      vatCheck && watch("vat_amount")
        ? Number(watch("vat_amount"))
        : vatCheck && watch("vat_id")?.vat_per != null
        ? Number(watch("vat_id")?.vat_per)
        : // : vatCheck && watch("vat_id")?.vat_per == null
          // ? Number(loggedUser?.settings?.tax)
          0

    const discountWatch = Number(watch("discount")) || 0

    // setValue("sub_total", salePriceWatch)

    switch (type) {
      case "sub_total": {
        setValue(
          `sub_total`,
          Number(salePriceWatch || 0)?.toFixed(desimalrange)
        )
        return Number(salePriceWatch || 0)?.toFixed(desimalrange)
      }
      case "discounted_amount": {
        const subTotal = calculationSale("sub_total")
        const discountedAmount = subTotal - (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "discounted_amount_send": {
        const subTotal = calculationSale("sub_total")
        const discountedAmount = (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }

      case "tax_total": {
        const baseAmount = discountCheck
          ? calculationSale("discounted_amount")
          : calculationSale("sub_total")

        const calcuMethod = watch("vat_id")?.vat_cal

        console.log(`calcuMethodcalcuMethod`, watch("vat_id"))

        const taxWatch =
          vatCheck && watch("vat_amount")
            ? Number(watch("vat_amount"))
            : vatCheck && watch("vat_id")?.vat_per != null
            ? Number(watch("vat_id")?.vat_per)
            : 0

        const retentionValue = retentionCheck ? watch("retention") : 0
        const advRetentionValue = advRetentionCheck ? watch("adv_retention") : 0

        const totalBeforeTax =
          calcuMethod == 1
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : Number(baseAmount)
        console.log(
          `totalBeforeTax`,
          totalBeforeTax,
          taxWatch,
          calcuMethod,
          retentionValue,
          advRetentionValue,
          baseAmount
        )

        const taxAmount = (totalBeforeTax * Number(taxWatch)) / 100
        return Number(taxAmount)?.toFixed(desimalrange)
      }
      case "total_amount": {
        const baseAmount = discountCheck
          ? calculationSale("discounted_amount")
          : calculationSale("sub_total")

        const calcuMethod = watch("vat_id")?.vat_cal

        const retentionValue = retentionCheck ? watch("retention") : 0
        const advRetentionValue = advRetentionCheck ? watch("adv_retention") : 0

        const totalBeforeTax =
          calcuMethod == 1
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : !vatCheck
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : Number(baseAmount)

        // const retentionAdded =
        //   (Number(salePriceWatch) * Number(retentionWatch)) / 100
        // const advRetentionAdded =
        //   (Number(salePriceWatch) * Number(advRetentionWatch)) / 100
        // const totalBeforeTax = Number(baseAmount)

        const taxAmount = (totalBeforeTax * taxWatch) / 100
        const totalAmount = Number(totalBeforeTax) + Number(taxAmount)
        setValue(`net_total`, Number(totalAmount)?.toFixed(2))
        return Number(totalAmount)?.toFixed(2)
      }

      default:
        return 0
    }
  }
  const voucherSource = useWatch({
    control,
    name: "voucher_source",
  })

  const calculateStockTotal = useMemo(() => {
    const price = voucherSource?.reduce((a, b) => Number(b.amount) + a, 0) || 0
    return Number(price)?.toFixed(desimalrange)
  }, [voucherSource])

  const handleVatType = e => {
    setValue("vat_amount", Number(e?.vat_per || 0))
    console.log(`handleVatType`, e)
  }

  const handlePOSelect = async item => {
    console.log(`itemsss`, item)

    setPoData(item)

    const previousDatas = getValues()
    // const partialPayment =
    console.log(`chk data new `, item)

    setValue(
      viewData?.type == "ref"
        ? `voucher_contra_ref.${contraId}.credit`
        : `voucher_contra_partial_pay.${contraId}.amount`,
      Number(item?.amount || 0)
    )
    setValue(
      viewData?.type == "ref"
        ? `voucher_contra_ref.${contraId}.voucher_id`
        : `voucher_contra_partial_pay.${contraId}.voucher_id`,
      item?.id
    )
    setValue(
      viewData?.type == "ref"
        ? `voucher_contra_ref.${contraId}.code`
        : `voucher_contra_partial_pay.${contraId}.code`,
      item?.code
    )

    // toggleSelect()
    // setModal(false)
    setContraId(null)
    setViewVouchersLi(false)
  }

  function ucfirst(str) {
    var firstLetter = str.substr(0, 1)
    return firstLetter.toUpperCase() + str.substr(1)
  }

  const [financeVoucherli, setFinanceVoucherLi] = useState()
  const RemoveItem = [
    "Payroll",
    // "Debit Note",
    "Rejection Out",
    // "Receipt Note",
    "Reversing Journal",
    "Material In",
    "Material Out",
    "Sales Order",
    "Memorandum",
    "Rejection In",
    "Delivery Note",
    "Goods Receipt Note",
    "Stock Journal",
    "Purchase Order",
    "Opening Balance",
  ]
  const [isCardOpen, setCardOpen] = useState(!editId ? true : false)

  const financeVoucherLi = async () => {
    setIsVoucherLoading(true)
    const voucherIdChk = getValues("voucher_id")
    console.log(`chkchk`, voucherIdChk)

    try {
      const responce = await getFinanceVoucherLi()
      setFinanceVoucherLi(responce?.data)
      if (!editId) {
        setValue(
          "voucher_id",
          voucherIdChk != undefined
            ? voucherIdChk
            : {
                label: responce?.data[0]?.voucher_type,
                value: responce?.data[0]?.id,
                ...responce?.data[0],
              }
        )
      }
    } finally {
      setIsVoucherLoading(false)
      setActiveItemId(voucherIdChk != undefined ? voucherIdChk?.value : 1)
      // activeItemId != null ? setActiveItemId(activeItemId) : setActiveItemId(1)
    }
  }

  useEffect(() => {
    financeVoucherLi()
  }, [])

  const handilUpdate = () => {
    setEditPartial(false)
  }

  // const handlePartyName = () => {
  //   const datas = getValues()
  // }
  const handlePartyName = () => {
    const datas = getValues()
    // Reset the fields when Party Name is selected
    setValue("project_ids", null)
    setValue("manufacturing_journal_id", null)
    setValue("sale_unit", "")
    setValue("sale_qty", "")
    setValue("sale_total", 0)
    setValue("chk_sale_total", 0)
  }

  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-3">
                  {fromDashboard ? (
                    <div></div>
                  ) : (
                    <Breadcrumbs
                      title="Finance"
                      breadcrumbObject={[
                        { title: "Finance", link: "/finance" },
                        { title: crumb || "Masters", link: "/finance" },
                        // { title: "Voucher Entries", link: "/finance-voucher" },
                        ...(crumb
                          ? [
                              {
                                title: "Purchase Orders",
                                link: "/procurement-purchaseorder",
                              },
                            ]
                          : [
                              {
                                title: "Voucher Entries",
                                link: "/finance-voucher",
                              },
                            ]),
                        {
                          title: id
                            ? `${
                                watch("voucher_id")
                                  ? `Edit ${watch("voucher_id")?.label} Voucher`
                                  : "Edit Voucher"
                              }`
                            : `${
                                watch("voucher_id")
                                  ? `${watch("voucher_id")?.label} Voucher`
                                  : "Add Voucher"
                              }`,
                          link: "",
                        },
                      ]}
                    />
                  )}
                  <div className="d-flex">
                    {watch("voucher_id")?.value ? (
                      <LoadingButton
                        form={`request-form`}
                        color={"primary"}
                        loading={isLoading}
                        className={"px-2 mb-3 btn btn-primary"}
                        type="submit"
                      >
                        {id
                          ? "Update"
                          : watch(`voucher_id`)?.value == 16
                          ? "Send for Approval"
                          : "Save"}
                      </LoadingButton>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Col lg="12">
                  <Row
                    className={isCardOpen === false && !editId ? "me-3" : ""}
                  >
                    <Col
                      lg={
                        location?.state?.type === "from_po"
                          ? "12"
                          : isCardOpen
                          ? "10"
                          : "12"
                      }
                    >
                      <Card className="invoice-main-card p-3 pt-4">
                        <Row>
                          <Col sm={9}>
                            {watch("voucher_id")?.label ? (
                              <div className="d-flex">
                                <div className="voucher-label me-2">
                                  {watch("voucher_id")?.label
                                    ? watch("voucher_id")?.label
                                    : "-"}{" "}
                                  No :
                                </div>
                                <UFInput
                                  control={control}
                                  placeholder="Code"
                                  name={`code`}
                                  disabled={
                                    watch("code_edit") == 0 ||
                                    watch("code_edit") == "undefined"
                                      ? true
                                      : false
                                  }
                                  // lockFirstNChars={3}
                                />
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                          {/* <Col sm={3}><div>Date</div></Col> */}
                          <Col sm={3}>
                            <FormGroup className="mb-4">
                              {/* <Label>Date</Label> */}
                              <UFDate
                                control={control}
                                placeholder="Enter the Date "
                                name={"po_date"}
                                disabled={true}
                              />
                              <FormFeedback invalid>
                                {errors.po_date?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col sm={6} lg={4} xl={3} className="d-none">
                            <FormGroup className="mb-4">
                              <Label>
                                Voucher Type{" "}
                                <span className="mandatory">*</span>
                              </Label>
                              <VoucherTypes
                                control={control}
                                placeholder="Select Voucher Type"
                                name={"voucher_id"}
                                target={fromDashboard ? ".modal" : "body"}
                                onSelectChange={e => handleVoucherType(e)}
                                invalid={!!errors.voucher_id}
                                disabled={
                                  editId
                                    ? true
                                    : location?.state?.id
                                    ? true
                                    : false
                                }
                                forInvoice={true}
                              />
                              <FormFeedback invalid>
                                {errors.voucher_id?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          {watch("voucher_id")?.value == 16 && (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>RFQ Reference</Label>
                                <RFQList
                                  control={control}
                                  name={"rfq_id"}
                                  placeholder={"Select the RFQ No"}
                                  target={fromDashboard ? ".modal" : "body"}
                                  onSelectChange={e => fetchRfqData(e?.id)}
                                  // clearable={true}
                                  approvedStatus={true}
                                  disabled={
                                    location?.state?.type === "from_po"
                                      ? false
                                      : location?.state?.id
                                      ? true
                                      : editId
                                      ? true
                                      : false
                                  }
                                />
                                <FormFeedback invalid>
                                  {errors.rfq_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}

                          {watch("rfq_id")?.value ? (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>RFQ Reference</Label>
                                <UFInput
                                  control={control}
                                  name={"rfq_ref_code"}
                                  placeholder={"Reference Code"}
                                />
                              </FormGroup>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {watch("voucher_id")?.value == 16 && (
                            <Col sm={6} lg={4} xl={3}>
                              <FormGroup>
                                <Label>
                                  Party Name
                                  <span className="mandatory">*</span>
                                </Label>
                                <FinanceLedgersLi
                                  control={control}
                                  placeholder="Select the Party Name"
                                  name={"credit_id"}
                                  invalid={!!errors.credit_id}
                                  target={"body"}
                                  groupId={
                                    [4, 15, 16].includes(
                                      watch("voucher_id")?.value
                                    )
                                      ? 22
                                      : 13
                                  }
                                  showCreateOption={true}
                                  refreshTrigger={refreshDropdown}
                                  onSuccess={handleLedgerCreationSuccess}
                                  disabled={
                                    location?.state?.type === "from_po"
                                      ? false
                                      : editId
                                      ? true
                                      : location?.state?.id
                                      ? true
                                      : false
                                  }
                                  onSelectChange={e => handlePartyName()}
                                />
                                <FormFeedback invalid>
                                  {errors.credit_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                          <Col sm={6} lg={4} xl={3}>
                            <FormGroup>
                              <Label>Contact Person</Label>
                              <SupplierContact
                                control={control}
                                placeholder="Select the Contact Person"
                                name={"sup_cont_per_id"}
                                invalid={!!errors.sup_cont_per_id}
                                target={"body"}
                                ledgerId={watch("credit_id")?.value}
                                showCreateOption={true}
                              />
                              <FormFeedback invalid>
                                {errors.credit_id?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          {watch("voucher_id")?.value == 16 && (
                            <>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Request Date</Label>
                                  <UFDate
                                    control={control}
                                    name={"request_date"}
                                    invalid={!!errors.request_date}
                                  />
                                  <FormFeedback invalid>
                                    {errors.request_date?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>

                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Exp Delivery Date</Label>
                                  <UFDate
                                    control={control}
                                    name={"exp_Delivery_date"}
                                    invalid={!!errors.exp_Delivery_date}
                                  />
                                  <FormFeedback invalid>
                                    {errors.exp_Delivery_date?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Shipping Address
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter the Shipping Address"
                                    rows="5"
                                    name={"address"}
                                    invalid={!!errors.address}
                                    className={"pb-0"}
                                  />
                                  <FormFeedback invalid>
                                    {errors.address?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </>
                          )}
                        </Row>

                        <hr className="m-0" />
                        {watch("voucher_id")?.value == 16 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      {/* <th>Description</th> */}
                                      <th>Unit</th>
                                      <th>Quantity</th>
                                      <th>Unit Price (AED)</th>
                                      <th>Price (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {materialFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          <ProductList
                                            control={control}
                                            placeholder="Select Product"
                                            // projectid={projectID}
                                            selectedProduct={watch(
                                              `voucher_materials`
                                            )}
                                            index={index}
                                            name={`voucher_materials.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleCompanyProduct(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.product_id?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        {/* <td className="ps-1">
                                          <div className="d-flex justify-content-between">
                                            <UFInput
                                              control={control}
                                              placeholder="Description"
                                              name={`voucher_materials.${index}.description`}
                                            />
                                            <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="svg-font pe-1 pointer"
                                    id={`PopoverLegacy-${index}`}
                                  >
                                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                  </svg>
                                  <UncontrolledPopover
                                    placement="bottom"
                                    target={`PopoverLegacy-${index}`}
                                    trigger="hover"
                                    container={
                                      fromDashboard ? ".modal" : "body"
                                    }
                                  >
                                    <PopoverBody>
                                      <div className="table-popup-content">
                                        <div className="pb-2">
                                          Recent Suppliers
                                        </div>
                                        {watch(
                                          `purchase.${index}.short_supplier`
                                        )?.map(dt => (
                                          <div className="py-1">
                                            <span>{dt?.suppliers_code}</span>{" "}
                                            <span className="ps-2">
                                              {dt?.name}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </PopoverBody>
                                  </UncontrolledPopover>
                                          </div>
                                        </td> */}
                                        <td className="ps-1">
                                          <Unit
                                            control={control}
                                            placeholder="Unit"
                                            name={`voucher_materials.${index}.unit`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_materials.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.qnt
                                            }
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.unit_price`}
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.unit_price?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.sub_price`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <img
                                              src={lightTrash}
                                              alt="light-trash"
                                              className="trash-img pointer"
                                              onClick={() =>
                                                materialListRemove(index)
                                              }
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                                {watch("material_request_id")?.value == null ? (
                                  <Col
                                    lg="12"
                                    xs={12}
                                    md={2}
                                    sm={12}
                                    className="d-flex justify-content-end"
                                  >
                                    {!fromDashboard && (
                                      <Button
                                        color="primary"
                                        className="addButton mt-2"
                                        onClick={() =>
                                          materialListAppend({
                                            product_id: "",
                                            description: "",
                                            qnt: "",
                                            discount: "",
                                            unit_price: "",
                                            sub_price: "",
                                          })
                                        }
                                      >
                                        + Row
                                      </Button>
                                    )}
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                {/* {watch("voucher_id")?.value != 16 && ( */}
                                <Row className="mb-0">
                                  <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleDiscountCheck(discountCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_discount"}
                                        checked={discountCheck}
                                      />
                                      <Label className="ms-2">Discount</Label>
                                    </FormGroup>
                                  </Col>
                                  {/* <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleShippingCheck(shippingCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_shipping"}
                                        checked={shippingCheck}
                                      />
                                      <Label className="ms-2">
                                        Shipping Charge
                                      </Label>
                                    </FormGroup>
                                  </Col>
                                  <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleOtherCheck(othersCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_others"}
                                        checked={othersCheck}
                                      />
                                      <Label className="ms-2">
                                        Other Charges
                                      </Label>
                                    </FormGroup>
                                  </Col> */}
                                  <Col
                                    lg={"auto"}
                                    onClick={() => handleVatCheck(vatCheck)}
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_vat"}
                                        checked={vatCheck}
                                      />
                                      <Label className="ms-2">
                                        VAT Applicable
                                      </Label>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  {discountCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          Discount
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"discount_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={25}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          // onSelectChange={e => handleVatType(e)}
                                          disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  {vatCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          VAT
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"vat_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={17}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e => handleVatType(e)}
                                          disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                                {/* )} */}
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>General Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"general_terms"}
                                        invalid={!!errors.general_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.general_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>Delivery Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"delivery_terms"}
                                        invalid={!!errors.delivery_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.delivery_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                              <Col sm={5}>
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Sub Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation("sub_total")}
                                        name={"sub_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {discountCheck && (
                                  <>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discount %
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder="Enter Discount"
                                            name={"discount"}
                                            invalid={!!errors.discount}
                                          />
                                        </FormGroup>
                                        <FormFeedback invalid>
                                          {errors.discount?.message}
                                        </FormFeedback>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discounted Sub Total
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder={calculation(
                                              "discounted_amount"
                                            )}
                                            name={"discounted_subTotal"}
                                            disabled={true}
                                            className={"form-disabled-place"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {/* {shippingCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Shipping Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Shipping charge"
                                          name={"shipping_charge"}
                                          invalid={!!errors.shipping_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.shipping_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )}
                                {othersCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Other Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Other charge"
                                          name={"other_charge"}
                                          invalid={!!errors.other_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.other_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )} */}
                                {vatCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        {/* VAT (
                                        {watch("vat_id")?.vat_per
                                          ? watch("vat_id")?.vat_per
                                          : loggedUser?.settings?.tax}
                                        )% */}
                                        VAT{" "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={false}
                                          maxNum={100}
                                          name={`vat_amount`}
                                          invalid={!!errors?.vat_amount}
                                          voucherTypes={true}
                                          className="vat-input"
                                        />
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder={calculation("tax_total")}
                                          name={"tax"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Net Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation(
                                          "total_amount"
                                        )}
                                        name={"net_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <></>
                        )}
                        {responseData ? (
                          <Row className="py-2">
                            <Col sm={7}>
                              <FormGroup className="mb-4">
                                <Label>Payment Terms</Label>
                                <div className="fs-13 ps-2">
                                  {responseData?.pay_terms}
                                </div>
                                {/* <UFEditor
                          control={control}
                          placeholder="Enter the Payment Terms"
                          rows="5"
                          name={"pay_terms"}
                          invalid={!!errors.pay_terms}
                          className={"pb-0"}
                        /> */}
                                {/* <RichTextEditor
                          control={control}
                          name={"pay_terms"}
                          invalid={!!errors.terms}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                        /> */}
                              </FormGroup>
                            </Col>
                            <Col lg={4}>
                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Sub Total
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.sub_total
                                      ? NumberFormat(
                                          Number(responseData?.sub_total),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Discount %
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.discount
                                      ? responseData?.discount
                                      : 0}{" "}
                                    %
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    VAT %
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.tax ? responseData?.tax : 0}{" "}
                                    %
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Shipping Charge
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.shipping_charge
                                      ? NumberFormat(
                                          Number(responseData?.shipping_charge),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Other Charge
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.other_charge
                                      ? NumberFormat(
                                          Number(responseData?.other_charge),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Total Amount
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.total_amount
                                      ? NumberFormat(
                                          Number(responseData?.total_amount),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        ) : (
                          <></>
                        )}
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggleSelect}
        size="xl"
        unmountOnClose={false}
        className="custom-modal-ht"
        backdrop={"static"}
      >
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-2">
                Details{" "}
                {[13, 15, 1, 3, 6, 8]?.includes?.(watch("voucher_id")?.value) &&
                watch("voucher_id")?.value == 13 &&
                rSelected == 1
                  ? calculationSale("total_amount")
                  : watch("voucher_id")?.value == 15 && rSelected == 1
                  ? calculation("total_amount")
                  : [13, 15, 1, 3, 6, 8]?.includes?.(
                      watch("voucher_id")?.value
                    ) &&
                    rSelected == 2 &&
                    watch(`voucher_contra.${viewData?.currIndex}.debit`) != 0
                  ? watch(`voucher_contra.${viewData?.currIndex}.debit`)
                  : [13, 15, 18].includes(watch("voucher_id")?.value) &&
                    rSelected == 3
                  ? ""
                  : watch(`voucher_contra.${viewData?.currIndex}.credit`)}
              </h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggleSelectModal}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="mb-4">
              <Col lg={12} className="mb-4">
                <table className="estimation-table mb-4">
                  <thead>
                    <tr>
                      <th>Reference Type</th>
                      <th>Reference</th>
                      <th>Due Date</th>
                      <th>Amount</th>
                      {/* <th>Dr/Cr</th> */}
                      {[13, 15, 6, 1, 3, 8].includes(
                        watch("voucher_id")?.value
                      ) && <th></th>}
                    </tr>
                  </thead>
                  <tbody>
                    {contraFieldsPartial?.map((item, index) => (
                      <>
                        <tr key={`purchase${item.id || index}`}>
                          <td>
                            <ReferenceType
                              control={control}
                              placeholder="Select"
                              name={`voucher_contra_partial_pay.${index}.ref_id`}
                              target=".modal"
                              onSelectChange={e => handleRefAgainst(e, index)}
                            />
                          </td>
                          <td>
                            <UFInput
                              control={control}
                              placeholder="Code"
                              name={`voucher_contra_partial_pay.${index}.code`}
                              className="ps-1"
                            />
                          </td>
                          <td>
                            <UFDate
                              control={control}
                              placeholder="Select Date"
                              name={`voucher_contra_partial_pay.${index}.date`}
                              className="ps-1"
                            />
                          </td>
                          <td>
                            <UFInputNumber
                              control={control}
                              placeholder="Amount"
                              name={`voucher_contra_partial_pay.${index}.amount`}
                              className="ps-1"
                              isDecimal={true}
                              decimalLength={desimalrange || 2}
                            />
                          </td>
                          {/* <td>
                            <DebitCreditDrop
                              control={control}
                              placeholder="Select"
                              name={`voucher_contra_partial_pay.${index}.nature`}
                              target=".modal"
                              // onSelectChange={e => handleNature(e?.value, index, "ref")}
                            />
                          </td> */}
                          {[13, 15, 6, 1, 3, 8].includes(
                            watch("voucher_id")?.value
                          ) && (
                            <td>
                              <div className="pb-1 px-2 d-flex justify-content-center">
                                <div
                                  className="trash-img pointer"
                                  onClick={() => contraPartialListRemove(index)}
                                >
                                  <TrashIcon />
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
                {[13, 15, 6, 1, 3, 8].includes(watch("voucher_id")?.value) && (
                  <div className="text-end mt-2 note-txt">
                    Press TAB to handle Values
                  </div>
                )}
                {/* {[13, 15].includes(watch("voucher_id")?.value) && (
                  <Col
                    lg="12"
                    xs={12}
                    md={2}
                    sm={12}
                    className="d-flex justify-content-end"
                  >
                    {!fromDashboard && (
                      <Button
                        color="primary"
                        className="addButton mt-2"
                        onClick={() => {
                          contraPartialListAppend({
                            account_id: "",
                            debit: 0,
                            credit: 0,
                            chk: viewData?.currIndex,
                            code: watch("code"),
                            nature:
                              watch("voucher_id")?.value == 13
                                ? { label: "Dr", value: "debit" }
                                : { label: "Cr", value: "credit" },
                          })
                          setViewVouchersLi(false)
                        }}
                      >
                        + Row
                      </Button>
                    )}
                  </Col>
                )} */}
              </Col>
              <Col lg="12">
                {viewVouchersLi ? (
                  <VoucherEntrySearch
                    fromDashboard={true}
                    editPartial={editPartial} // Added by Adithyan
                    editId={editId} // Added by Adithyan
                    handilUpdate={handilUpdate} // Added by Adithyan
                    onSelect={handlePOSelect}
                    voucherType={viewData?.voucher_type}
                    ledgerId={viewData?.ledger_id}
                    partialPayment={true}
                    voucherLocation={watch("voucher_id")?.value}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            {[1, 3, 4].includes(rSelected) &&
            [13, 15].includes(watch("voucher_id")?.value) ? (
              <LoadingButton
                form={`request-form`}
                color={"primary"}
                loading={isLoading}
                disabled={isLoading}
                type="submit"
              >
                Save
              </LoadingButton>
            ) : (
              <LoadingButton
                color={"primary"}
                // loading={isLoading}
                // disabled={isLoading}
                // type={rSelected == 1 ? "submit" : "button"}
                // onClick={() => handleModalData(viewData?.currIndex)}
                onClick={() => handleModalData(viewData?.currIndex)}
              >
                Save
              </LoadingButton>
            )}
          </ModalFooter>
        </>
      </Modal>
      <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
        <ModalHeader toggle={() => setConfirmModal(false)}>
          Do you want to Print?
        </ModalHeader>

        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmModal(false)}>
            No
          </Button>
          <Button
            color="primary"
            // onClick={async () => {
            //   if (confirmType === "delete") {
            //     await handleDelete(selectedId)
            //   } else if (confirmType === "cancel") {
            //     await handleCancel(selectedId)
            //   }
            //   setConfirmModal(false)
            // }}
            // onClick={() => setConfirmModal(false)}
            onClick={() => {
              openAndPrintFile({
                url: `invoice/${printID}`,
                extension: "pdf",
              })
              setConfirmModal(false)
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={ccModal}
        toggle={() => setCCModal(false)}
        unmountOnClose={false}
      >
        <ModalHeader toggle={() => setCCModal(false)}>Details</ModalHeader>
        <ModalBody>
          {viewData?.showCC ? (
            <Col lg="12" xs={12} md={12} sm={12}>
              <FormGroup className="mb-4">
                <Label>Cost Center</Label>
                <FinCostCenterLi
                  control={control}
                  placeholder="Select"
                  name={`cost_center_id`}
                  invalid={!!errors?.cost_center_id}
                />
                <FormFeedback invalid>
                  {errors?.cost_center_id?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
          ) : (
            <></>
          )}
          {viewData?.taxChk == 1 ? (
            <Col lg="12" xs={12} md={12} sm={12}>
              <FormGroup className="mb-4">
                <Label>Nature Of Transactions</Label>
                <NatureOfTransactions
                  control={control}
                  placeholder="Select"
                  name={`transaction_type`}
                  invalid={!!errors?.transaction_type}
                />
                <FormFeedback invalid>
                  {errors?.transaction_type?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
          ) : (
            <></>
          )}
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleCCModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal>
      {/* <Modal
        isOpen={transactionModal}
        toggle={() => setTransactionModal(false)}
        unmountOnClose={false}
      >
        <ModalHeader toggle={() => setTransactionModal(false)}>
          Select Nature of Transaction
        </ModalHeader>
        <ModalBody>
          <Col lg="12" xs={12} md={12} sm={12}>
            <FormGroup className="mb-4">
              <Label>
                Nature Of Transactions
              </Label>
              <NatureOfTransactions
                control={control}
                placeholder="Select"
                name={`transaction_type`}
                invalid={!!errors?.transaction_type}
              />
              <FormFeedback invalid>
                {errors?.transaction_type?.message}
              </FormFeedback>
            </FormGroup>
          </Col>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleTransactionModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal> */}
      <Modal
        isOpen={bankModal}
        toggle={handleBankModalClose}
        size="xl"
        unmountOnClose={false}
        className="custom-modal-ht"
        backdrop={"static"}
      >
        <ModalHeader toggle={handleBankModalClose}>Bank Details</ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Payment Type</Label>
                <BankPaymentType
                  control={control}
                  placeholder="Select"
                  name={`payment_type_id`}
                  invalid={!!errors?.payment_type_id}
                />
                <FormFeedback invalid>
                  {errors?.payment_type_id?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            {watch("payment_type_id")?.value == 3 ? (
              <Col
                lg={"auto"}
                className="mt-auto"
                onClick={() => handlePDCCheck(pdcCheck)}
              >
                <FormGroup>
                  <input
                    type="checkbox"
                    className="ever-rise-checkbox"
                    name={"is_pdc"}
                    checked={pdcCheck}
                  />
                  <Label className="ms-2">PDC</Label>
                </FormGroup>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Date</Label>
                <UFDate
                  control={control}
                  placeholder="Enter the Date "
                  name={"bank_date"}
                  disabled={true}
                />
                <FormFeedback invalid>{errors.bank_date?.message}</FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Instrument Number</Label>
                <UFInput
                  control={control}
                  placeholder="Enter Instrument Number"
                  name={`instrument_no`}
                  invalid={!!errors?.instrument_no}
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.instrument_no?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Instrument Date</Label>
                <UFDate
                  control={control}
                  placeholder="Enter the Date "
                  name={"instrument_date"}
                  minDate={
                    pdcCheck
                      ? moment().add(1, "day").startOf("day").toDate()
                      : undefined
                  }
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.instrument_date?.message}
                </FormFeedback>
              </FormGroup>
            </Col>

            {watch("payment_type_id")?.value == 2 ? (
              <Col lg="4" xs={12} md={6} sm={12}>
                <FormGroup className="mb-4">
                  <Label>Currency</Label>
                  <BankCurrency
                    control={control}
                    placeholder="Select"
                    name={`currency`}
                    invalid={!!errors?.currency}
                  />
                  <FormFeedback invalid>
                    {errors?.currency?.message}
                  </FormFeedback>
                </FormGroup>
              </Col>
            ) : (
              <></>
            )}
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Amount</Label>
                <UFInputNumber
                  control={control}
                  placeholder="Enter Amount"
                  name={`bank_amount`}
                  invalid={!!errors?.bank_amount}
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.bank_amount?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Remarks</Label>
                <UFEditor
                  control={control}
                  placeholder="Enter the Remarks"
                  rows="5"
                  name={"remarks"}
                  invalid={!!errors.remarks}
                  className={"pb-0"}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleBankModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default EditPurchase
